export const Scene_data = [
    {
        "id": 37,
        "title": "RETREAT - Palm Beach Chair",
        "uuid": 37,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.17,
            0.51,
            1.85
        ],
        "product": "Retreat_palm_beach_chair",
        "dimention": [
            0.837,
            0.95,
            0.837
        ],
        "dimentionText": [
            "33.5\"",
            "38\"",
            "33.5\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "retreatFabricFinish": {
                    "default": "Oxford Stripe : Marine",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.25
        ],
        "variant": null,
        "modelLink": "models/Palm Beach Chair.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 7,
        "title": "Daphne Chair",
        "uuid": 7,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.35,
            0
        ],
        "cameraInitPos": [
            -1.17,
            0.51,
            1.85
        ],
        "product": "Daphne_chair",
        "dimention": [
            0.625,
            0.625,
            0.775
        ],
        "dimentionText": [
            "25\"",
            "25\"",
            "31\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Thatch : Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        -0.14,
                        0.17
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.25
        ],
        "variant": null,
        "modelLink": "models/Daphne Chair.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 41,
        "title": "Daphne Long Sofa",
        "uuid": 41,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.72,
            0.61,
            3.45
        ],
        "product": "Daphne_long_sofa_x",
        "dimention": [
            2.325,
            0.975,
            0.925
        ],
        "dimentionText": [
            "93\"",
            "39\"",
            "37\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Plain Jane : Skyline",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        -0.13,
                        0.2
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Daphne Long Sofa.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 48,
        "title": "Hutton Sofa",
        "uuid": 48,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.72,
            0.61,
            3.45
        ],
        "product": "Hutton_sofa",
        "dimention": [
            2.112,
            0.975,
            0.875
        ],
        "dimentionText": [
            "84.5\"",
            "39\"",
            "35\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Mix Tape : Lagoon",
                    "reapeatFactor": [
                        3,
                        3
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "legFinish": {
                    "default": "Nordic",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Hutton Sofa.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 21,
        "title": "Milly Twin Sleeper Chair",
        "uuid": 21,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -0.91,
            0.35,
            2.86
        ],
        "product": "Milly_twin_sleeper_chair",
        "dimention": [
            1.1375,
            0.9,
            0.85
        ],
        "dimentionText": [
            "45.5\"",
            "36\"",
            "34\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Thatch : Bluebell",
                    "reapeatFactor": [
                        0.95,
                        0.95
                    ],
                    "offsetFactor": [
                        -0.05,
                        0.35
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.5
        ],
        "variant": null,
        "modelLink": "models/Milly Twin Sleeper Chair.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 13,
        "title": "Hannah Chair",
        "uuid": 13,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.17,
            0.51,
            1.85
        ],
        "product": "Hannah_chair",
        "dimention": [
            0.75,
            0.9,
            0.9375
        ],
        "dimentionText": [
            "30\"",
            "36\"",
            "37.5\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "reapeatFactor": [
                        1.125,
                        1.125
                    ],
                    "offsetFactor": [
                        -0.36,
                        0.8
                    ],
                    "default": "Thatch : Bluebell"
                },
                "legFinish": {
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ],
                    "default": "Nordic"
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.25
        ],
        "variant": null,
        "modelLink": "models/Hannah Chair.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 18,
        "title": "Lucy Chair",
        "uuid": 18,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -5,
            1.25,
            10
        ],
        "product": "Lucy_chair",
        "dimention": [
            0.875,
            0.95,
            1
        ],
        "dimentionText": [
            "35\"",
            "38\"",
            "40\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Thatch : Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "legFinish": {
                    "default": "Nordic",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            0,
            5
        ],
        "variant": "Swivel Glider",
        "modelLink": "models/Lucy Chair_Swivel Glider.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 79,
        "title": "Hooks - 3",
        "uuid": 79,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.1,
            0
        ],
        "cameraInitPos": [
            -1.22,
            0.5,
            1.95
        ],
        "product": "Hooks_3",
        "dimention": [
            0.6,
            0.025,
            0.2
        ],
        "dimentionText": [
            "24\"",
            "1\"",
            "8\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Ryegrass",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Hooks - 3.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 52,
        "title": "Stevie Sofa",
        "uuid": 52,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.72,
            0.61,
            3.45
        ],
        "product": "Stevie_sofa_x",
        "dimention": [
            2.175,
            0.9,
            0.9
        ],
        "dimentionText": [
            "87\"",
            "36\"",
            "36\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Beach House Linen : Vast Sky",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        -0.14,
                        0.19
                    ]
                },
                "legFinish": {
                    "default": "Nordic",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Stevie Sofa - X.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 8,
        "title": "Eleanor Chair",
        "uuid": 8,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.4,
            0
        ],
        "cameraInitPos": [
            -1.07,
            0.61,
            1.85
        ],
        "product": "Eleanor_chair",
        "dimention": [
            0.775,
            0.925,
            0.975
        ],
        "dimentionText": [
            "31\"",
            "37\"",
            "39\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Shore-Bet : Sprout",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        -0.13,
                        0.19
                    ]
                },
                "legPaintColorFinish": {
                    "default": "Nordic",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.25
        ],
        "variant": null,
        "modelLink": "models/Eleanor Chair.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 26,
        "title": "Quinn Chair",
        "uuid": 26,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.17,
            0.51,
            1.85
        ],
        "product": "Quinn_chair",
        "dimention": [
            0.725,
            0.825,
            0.862
        ],
        "dimentionText": [
            "29\"",
            "33\"",
            "34.5\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Thatch : Bluebell",
                    "reapeatFactor": [
                        1,
                        1.09
                    ],
                    "offsetFactor": [
                        -0.13,
                        0.01
                    ]
                },
                "legFinish": {
                    "default": "Nordic",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.25
        ],
        "variant": "With Nailheads",
        "modelLink": "models/Quinn Chair.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 28,
        "title": "Stevie Chair",
        "uuid": 28,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -5,
            1.25,
            10
        ],
        "product": "Stevie_chair",
        "dimention": [
            0.875,
            0.9,
            0.9
        ],
        "dimentionText": [
            "35\"",
            "36\"",
            "36\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Thatch : Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "legFinish": {
                    "default": "Nordic",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            0,
            5
        ],
        "variant": null,
        "modelLink": "models/Stevie Chair.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 40,
        "title": "Blair Sofa",
        "uuid": 40,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.72,
            0.61,
            3.45
        ],
        "product": "Blair_sofa",
        "dimention": [
            2.237,
            1.1,
            0.787
        ],
        "dimentionText": [
            "89.5\"",
            "44\"",
            "31.5\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Thatch : Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        -0.12,
                        0.22
                    ]
                },
                "legFinish": {
                    "default": "Nordic",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            0,
            5
        ],
        "variant": null,
        "modelLink": "models/Blair Sofa.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 39,
        "title": "RETREAT - Nantucket Sofa",
        "uuid": 39,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.72,
            0.61,
            3.45
        ],
        "product": "Retreat_nantucket_sofa",
        "dimention": [
            2.063,
            0.812,
            0.912
        ],
        "dimentionText": [
            "82.5\"",
            "34.5\"",
            "36.5\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "retreatFabricFinish": {
                    "default": "Oxford Stripe : Greenery",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            0,
            5
        ],
        "variant": null,
        "modelLink": "models/Nantucket Sofa.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 35,
        "title": "RETREAT - Nantucket Chair",
        "uuid": 35,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.17,
            0.51,
            1.85
        ],
        "product": "Retreat_nantucket_chair",
        "dimention": [
            0.912,
            0.812,
            0.912
        ],
        "dimentionText": [
            "36.5\"",
            "34.5\"",
            "36.5\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "retreatFabricFinish": {
                    "default": "Shore-Bet : Vast Sky",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.25
        ],
        "variant": null,
        "modelLink": "models/Nantucket Chair.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 6,
        "title": "Billie Chair",
        "uuid": 6,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.4,
            0
        ],
        "cameraInitPos": [
            -1.17,
            0.51,
            1.85
        ],
        "product": "Billie_chair",
        "dimention": [
            0.625,
            0.625,
            0.775
        ],
        "dimentionText": [
            "25\"",
            "25\"",
            "31\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Crazy Daisy : Nikko Blue",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        -0.16,
                        0.19
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.25
        ],
        "variant": null,
        "modelLink": "models/Billie Chair.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 31,
        "title": "Winnie Chair",
        "uuid": 31,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -5,
            1.25,
            10
        ],
        "product": "Winnie_chair",
        "dimention": [
            0.75,
            0.95,
            0.9
        ],
        "dimentionText": [
            "30\"",
            "38\"",
            "36\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Thatch : Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            0,
            5
        ],
        "variant": null,
        "modelLink": "models/Winnie Chair.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 10,
        "title": "Flora Chair",
        "uuid": 10,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.17,
            0.51,
            1.85
        ],
        "product": "Flora_chair",
        "dimention": [
            0.875,
            0.95,
            0.95
        ],
        "dimentionText": [
            "35\"",
            "38\"",
            "38\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Thatch : Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        -0.15,
                        0.3
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.25
        ],
        "variant": null,
        "modelLink": "models/Flora Chair.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 46,
        "title": "Francine Sofa",
        "uuid": 46,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.72,
            0.61,
            3.45
        ],
        "product": "Francine_sofa_x",
        "dimention": [
            2.175,
            0.9,
            0.9
        ],
        "dimentionText": [
            "87\"",
            "36\"",
            "36\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Shore-Bet : Bermuda Beach",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        -0.08,
                        0.31
                    ]
                },
                "legFinish": {
                    "default": "Nordic",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Francine Sofa - X.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 65,
        "title": "Lillian Bench",
        "uuid": 65,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.13,
            0.5,
            2.27
        ],
        "product": "Lillian_bench",
        "dimention": [
            1.225,
            0.525,
            0.487
        ],
        "dimentionText": [
            "49\"",
            "21\"",
            "19.5\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Freckles : Zinnia",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "metalLegFinish": {
                    "default": "Bronzed Metal",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Lillian Bench.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 89,
        "title": "Low Tide Day Bed",
        "uuid": 89,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.72,
            0.61,
            3.45
        ],
        "product": "Low_tide_day_bed",
        "dimention": [
            2.025,
            1.06875,
            1.025
        ],
        "dimentionText": [
            "81\"",
            "42.75\"",
            "41\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Ryegrass",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Low Tide Day Bed.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 57,
        "title": "Cube Ottoman",
        "uuid": 57,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -0.94,
            0.61,
            1.94
        ],
        "product": "Cube_ottoman",
        "dimention": [
            0.5,
            0.5,
            0.512
        ],
        "dimentionText": [
            "20\"",
            "20\"",
            "20.5\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Hydrangea Holiday : Marine",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0.1,
                        -0.16
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Cube Ottoman.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 104,
        "title": "Fiddlehead Cocktail Table",
        "uuid": 104,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.1,
            0
        ],
        "cameraInitPos": [
            -0.68,
            0.62,
            2.05
        ],
        "product": "Fiddlehead_cocktail_table",
        "dimention": [
            0.95,
            0.95,
            0.55
        ],
        "dimentionText": [
            "38\"",
            "38\"",
            "22\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Cloud",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1.5,
            5
        ],
        "variant": null,
        "modelLink": "models/Fiddlehead Cocktail Table.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 9,
        "title": "Evy Chair",
        "uuid": 9,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.17,
            0.51,
            1.85
        ],
        "product": "Evy_chair",
        "dimention": [
            0.825,
            0.975,
            0.975
        ],
        "dimentionText": [
            "33\"",
            "39\"",
            "39\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Thatch : Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        -0.13,
                        0.2
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.25
        ],
        "variant": null,
        "modelLink": "models/Evy Chair.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 75,
        "title": "Suri Ottoman",
        "uuid": 75,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.1,
            0
        ],
        "cameraInitPos": [
            -1.22,
            0.5,
            1.95
        ],
        "product": "Suri_ottoman",
        "dimention": [
            0.675,
            0.675,
            0.475
        ],
        "dimentionText": [
            "27\"",
            "27\"",
            "19\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Freckles : Greenery",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Suri Ottoman.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 64,
        "title": "James Ottoman",
        "uuid": 64,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -0.94,
            0.61,
            1.94
        ],
        "product": "James_ottoman",
        "dimention": [
            0.7,
            0.35,
            0.7
        ],
        "dimentionText": [
            "28\"",
            "14\"",
            "28\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Grand Mum : Oyster",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0.1,
                        -0.35
                    ]
                },
                "legFinish": {
                    "default": "Nordic",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/James Ottoman.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 180,
        "title": "Molly Bench",
        "uuid": 180,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.13,
            0.5,
            2.27
        ],
        "product": "Molly_bench",
        "dimention": [
            0.8,
            0.425,
            0.475
        ],
        "dimentionText": [
            "32\"",
            "17\"",
            "19\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Molly Bench.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 90,
        "title": "Mabel Bed",
        "uuid": 90,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.8,
            0
        ],
        "cameraInitPos": [
            -2.94,
            0.83,
            4.52
        ],
        "product": "Mabel_bed",
        "dimention": [
            1.05,
            2,
            1.28
        ],
        "dimentionText": [
            "41.75\"",
            "80\"",
            "51.75\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ],
                    "default": "Bluebell"
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1.5,
            5
        ],
        "variant": "Twin",
        "modelLink": "models/Mabel Bed_Twin.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 80,
        "title": "Hooks - 5",
        "uuid": 80,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.1,
            0
        ],
        "cameraInitPos": [
            -1.22,
            0.5,
            1.95
        ],
        "product": "Hooks_5",
        "dimention": [
            1,
            0.025,
            0.2
        ],
        "dimentionText": [
            "40\"",
            "1\"",
            "8\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Vast Sky",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Hooks - 5.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 50,
        "title": "Monty Sofa",
        "uuid": 50,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.72,
            0.61,
            3.45
        ],
        "product": "Monty_sofa",
        "dimention": [
            2.1,
            0.925,
            0.875
        ],
        "dimentionText": [
            "84\"",
            "37\"",
            "35\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Boomerang : Cloud",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "legFinish": {
                    "default": "Nordic",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Monty Sofa.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 72,
        "title": "Shelby Bench",
        "uuid": 72,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.13,
            0.5,
            2.27
        ],
        "product": "Shelby_bench",
        "dimention": [
            1.3,
            0.8,
            0.5
        ],
        "dimentionText": [
            "52\"",
            "32\"",
            "20\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Boomerang: Sage",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "legFinish": {
                    "default": "Limewash",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Shelby Bench.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 53,
        "title": "Wilton Skirted Sofa",
        "uuid": 53,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.72,
            0.61,
            3.45
        ],
        "product": "Wilton_skirted_sofa",
        "dimention": [
            2.1,
            0.875,
            0.925
        ],
        "dimentionText": [
            "84\"",
            "35\"",
            "37\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Leaflette : Marine",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        -0.14,
                        0.23
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Wilton Skirted Sofa.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 49,
        "title": "Joey Sofa",
        "uuid": 49,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.72,
            0.61,
            3.45
        ],
        "product": "Joey_sofa",
        "dimention": [
            2.1,
            1,
            0.875
        ],
        "dimentionText": [
            "84\"",
            "40\"",
            "35\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Tweedy : Oyster",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        -0.12,
                        0.19
                    ]
                },
                "legFinish": {
                    "default": "Nordic",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Joey Sofa.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 62,
        "title": "Flora Ottoman",
        "uuid": 62,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -0.94,
            0.61,
            1.94
        ],
        "product": "Flora_ottoman",
        "dimention": [
            0.725,
            0.6,
            0.475
        ],
        "dimentionText": [
            "29\"",
            "24\"",
            "19\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Clambake: Marine",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Flora Ottoman.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 42,
        "title": "Daphne Sofa",
        "uuid": 42,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.72,
            0.61,
            3.45
        ],
        "product": "Daphne_sofa_x",
        "dimention": [
            2.1,
            0.975,
            0.925
        ],
        "dimentionText": [
            "84\"",
            "39\"",
            "37\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Washed Out : Vast Sky",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        -0.13,
                        0.25
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Daphne Sofa.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 44,
        "title": "Flora Sofa (and loveseat)",
        "uuid": 44,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.72,
            0.61,
            3.45
        ],
        "product": "Flora_sofa_and_loveseat",
        "dimention": [
            2.1,
            0.95,
            0.95
        ],
        "dimentionText": [
            "84\"",
            "38\"",
            "38\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Thatch : Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        -0.15,
                        0.22
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Flora Sofa and loveseat.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 68,
        "title": "Milly Storage Ottoman",
        "uuid": 68,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.13,
            0.5,
            2.27
        ],
        "product": "Milly_storage_ottoman",
        "dimention": [
            0.975,
            0.65,
            0.425
        ],
        "dimentionText": [
            "39\"",
            "26\"",
            "17\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Shell Game : Marine",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0.11,
                        0.62
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Milly Storage Ottoman.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 51,
        "title": "Shelby Sofa",
        "uuid": 51,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.72,
            0.61,
            3.45
        ],
        "product": "Shelby_sofa",
        "dimention": [
            2.175,
            0.95,
            0.825
        ],
        "dimentionText": [
            "87\"",
            "38\"",
            "33\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Laguna : Pear",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        -0.15,
                        0.26
                    ]
                },
                "legFinish": {
                    "default": "Nordic",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Shelby Sofa.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 111,
        "title": "Boothbay Dining Cushion ONLY",
        "uuid": 111,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            0,
            1.3,
            0.03
        ],
        "product": "Boothbay_dining_cushion_only",
        "dimention": [
            0.5,
            0.6,
            0.09625
        ],
        "dimentionText": [
            "20\"",
            "24\"",
            "3.85\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Boomerang: Sage",
                    "reapeatFactor": [
                        1.25,
                        1.25
                    ],
                    "offsetFactor": [
                        0.14,
                        0.38
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Boothbay Dining Cushion.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 147,
        "title": "Margate Dining Table",
        "uuid": 147,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -2.05,
            1.05,
            3.11
        ],
        "product": "Margate_dining_table",
        "dimention": [
            1.5,
            0.825,
            0.75
        ],
        "dimentionText": [
            "60\"",
            "33\"",
            "30\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "woodTopFinish": {
                    "default": "Painted",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            3.5
        ],
        "variant": "Seats 4",
        "modelLink": "models/Margate Dining Table_4.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 109,
        "title": "Tide Pool Hall Table",
        "uuid": 109,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.6,
            0.68,
            2.82
        ],
        "product": "Tide_pool_hall_table",
        "dimention": [
            1.0625,
            0.4,
            0.8125
        ],
        "dimentionText": [
            "42.5\"",
            "16\"",
            "32.5\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Tide Pool Hall Table.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 116,
        "title": "Cokie Counter Stool - Natural",
        "uuid": 116,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -5,
            1.25,
            10
        ],
        "product": "Cokie_counter_stool_natural",
        "dimention": [
            0.5,
            0.55,
            1.025
        ],
        "dimentionText": [
            "20\"",
            "22\"",
            "41\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "chairFrameFinish": {
                    "default": "Natural Maple",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "cushionFinish": {
                    "default": "No Cushion",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            0,
            5
        ],
        "variant": null,
        "modelLink": "models/Cokie Counter Stool - Natural.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 120,
        "title": "Cokie Dining Chair - Natural",
        "uuid": 120,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -5,
            1.25,
            10
        ],
        "product": "Cokie_dining_chair_natural",
        "dimention": [
            0.55,
            0.55,
            0.9
        ],
        "dimentionText": [
            "20\"",
            "22\"",
            "36\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "chairFrameFinish": {
                    "default": "Natural Maple",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "cushionFinish": {
                    "default": "No Cushion",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            0,
            5
        ],
        "variant": null,
        "modelLink": "models/Cokie Dining Chair - Natural.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 105,
        "title": "Frannie Coffee Table",
        "uuid": 105,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.1,
            0
        ],
        "cameraInitPos": [
            -0.68,
            0.62,
            2.05
        ],
        "product": "Frannie_coffee_table",
        "dimention": [
            1.2,
            1.2,
            0.475
        ],
        "dimentionText": [
            "48\"",
            "48\"",
            "19\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bisque",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "woodTopFinish": {
                    "default": "Matte Glazed White Oak",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1.5,
            5
        ],
        "variant": null,
        "modelLink": "models/Frannie Coffee Table.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 115,
        "title": "Cokie Barstool - Painted",
        "uuid": 115,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.4,
            0
        ],
        "cameraInitPos": [
            -0.57,
            0.45,
            1.59
        ],
        "product": "Cokie_barstool_painted",
        "dimention": [
            0.5,
            0.55,
            1.125
        ],
        "dimentionText": [
            "20\"",
            "22\"",
            "45\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Zinnia",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "cushionFinish": {
                    "default": "No Cushion",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        -0.13,
                        0.2
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.25
        ],
        "variant": null,
        "modelLink": "models/Cokie Barstool - Painted.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 94,
        "title": "Shutter Bunk Bed",
        "uuid": 94,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -5,
            1.25,
            10
        ],
        "product": "Shutter_bunk_bed",
        "dimention": [
            1.05,
            2,
            1.825
        ],
        "dimentionText": [
            "42\"",
            "80\"",
            "73\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            0,
            5
        ],
        "variant": null,
        "modelLink": "models/Shutter Bunk Bed.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 98,
        "title": "Cable Lock Coffee Table",
        "uuid": 98,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -5,
            1.25,
            10
        ],
        "product": "Cable_lock_coffee_table",
        "dimention": [
            0.85,
            0.85,
            0.45
        ],
        "dimentionText": [
            "34\"",
            "34\"",
            "18\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "woodTopFinish": {
                    "default": "Painted",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            0,
            5
        ],
        "variant": null,
        "modelLink": "models/Cable Lock Coffee Table.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 88,
        "title": "Island Settee",
        "uuid": 88,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.72,
            0.61,
            3.45
        ],
        "product": "Island_settee",
        "dimention": [
            2.025,
            1.05,
            1.025
        ],
        "dimentionText": [
            "81\"",
            "42\"",
            "41\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Island Settee.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 103,
        "title": "Della Cocktail Table",
        "uuid": 103,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.1,
            0
        ],
        "cameraInitPos": [
            -0.68,
            0.62,
            2.05
        ],
        "product": "Della_cocktail_table",
        "dimention": [
            1.05,
            1.05,
            0.45
        ],
        "dimentionText": [
            "42\"",
            "42\"",
            "18\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1.5,
            5
        ],
        "variant": null,
        "modelLink": "models/Della Cocktail Table.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 119,
        "title": "Cokie Desk Chair - Painted",
        "uuid": 119,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.4,
            0
        ],
        "cameraInitPos": [
            -0.57,
            0.45,
            1.59
        ],
        "product": "Cokie_desk_chair_painted",
        "dimention": [
            0.6375,
            0.6875,
            0.95
        ],
        "dimentionText": [
            "25.5\"",
            "27.5\"",
            "38\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "cushionFinish": {
                    "default": "No Cushion",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.25
        ],
        "variant": null,
        "modelLink": "models/Cokie Desk Chair - Painted.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 134,
        "title": "Sanibel Counter Stool - Painted",
        "uuid": 134,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -5,
            1.25,
            10
        ],
        "product": "Sanibel_counter_stool_painted",
        "dimention": [
            0.3875,
            0.3875,
            0.6
        ],
        "dimentionText": [
            "15.5\"",
            "15.5\"",
            "24\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            0,
            5
        ],
        "variant": null,
        "modelLink": "models/Sanibel Counter Stool - Painted.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 91,
        "title": "Meriweather Bed",
        "uuid": 91,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.8,
            0
        ],
        "cameraInitPos": [
            -2.94,
            0.83,
            4.52
        ],
        "product": "Meriweather_bed",
        "dimention": [
            1.05,
            2,
            1.3
        ],
        "dimentionText": [
            "42\"",
            "80\"",
            "53\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1.5,
            5
        ],
        "variant": "Twin",
        "modelLink": "models/Meriweather Bed_Twin.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 87,
        "title": "Island Bed",
        "uuid": 87,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.8,
            0
        ],
        "cameraInitPos": [
            -2.94,
            0.83,
            4.52
        ],
        "product": "Island_bed",
        "dimention": [
            1.05,
            2,
            1.275
        ],
        "dimentionText": [
            "42\"",
            "80\"",
            "51\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1.5,
            5
        ],
        "variant": "Twin",
        "modelLink": "models/Island Bed_Twin.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 142,
        "title": "Cable Lock Dining Table",
        "uuid": 142,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -2.05,
            1.05,
            3.11
        ],
        "product": "Cable_lock_dining_table",
        "dimention": [
            1.05,
            1.7,
            0.75
        ],
        "dimentionText": [
            "42\"",
            "68\"",
            "30\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "woodTopFinish": {
                    "default": "Painted",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            3.5
        ],
        "variant": "Seats 4",
        "modelLink": "models/Cable Lock Dining Table_4.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 73,
        "title": "Shelby Ottoman",
        "uuid": 73,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.1,
            0
        ],
        "cameraInitPos": [
            -1.22,
            0.5,
            1.95
        ],
        "product": "Shelby_ottoman",
        "dimention": [
            0.625,
            0.5,
            0.45
        ],
        "dimentionText": [
            "25\"",
            "20\"",
            "18\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Leaflette : Porch",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        -0.14,
                        0.16
                    ]
                },
                "legFinish": {
                    "default": "Limewash",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Shelby Ottoman.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 102,
        "title": "Chesapeake Coffee Table",
        "uuid": 102,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.1,
            0
        ],
        "cameraInitPos": [
            -0.68,
            0.62,
            2.05
        ],
        "product": "Chesapeake_coffee_table",
        "dimention": [
            0.8,
            0.5375,
            0.475
        ],
        "dimentionText": [
            "32\"",
            "21.5\"",
            "19\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1.5,
            5
        ],
        "variant": null,
        "modelLink": "models/Chesapeake Coffee Table.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 178,
        "title": "Lottie Dining Bench",
        "uuid": 178,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.13,
            0.5,
            2.27
        ],
        "product": "Lottie_dining_bench",
        "dimention": [
            1.125,
            0.45,
            0.475
        ],
        "dimentionText": [
            "45\"",
            "18\"",
            "19\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "woodTopFinish": {
                    "default": "Painted",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Lottie Dining Bench.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 182,
        "title": "Addy Side Table with Shelf",
        "uuid": 182,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -0.94,
            0.61,
            1.94
        ],
        "product": "Addy_side_table_with_shelf",
        "dimention": [
            0.5,
            0.5,
            0.75
        ],
        "dimentionText": [
            "20\"",
            "20\"",
            "30\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Vast Sky",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Addy Side Table with Shelf.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 159,
        "title": "Bay 2-Over-4-Dresser",
        "uuid": 159,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -5,
            1.25,
            10
        ],
        "product": "Bay_2over4dresser",
        "dimention": [
            0.925,
            0.525,
            1.35
        ],
        "dimentionText": [
            "37\"",
            "21\"",
            "54\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Vast Sky",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            0,
            5
        ],
        "variant": null,
        "modelLink": "models/Bay 2-Over-4-Dresser.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 158,
        "title": "Bay 3-Drawer Dresser",
        "uuid": 158,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -5,
            1.25,
            10
        ],
        "product": "Bay_3drawer_dresser",
        "dimention": [
            0.5,
            0.35,
            0.725
        ],
        "dimentionText": [
            "20\"",
            "14\"",
            "29\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Vast Sky",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            0,
            5
        ],
        "variant": null,
        "modelLink": "models/Bay 3-Drawer Dresser.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 155,
        "title": "Addy Double Dresser 65",
        "uuid": 155,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.72,
            0.61,
            3.45
        ],
        "product": "Addy_double_dresser_65",
        "dimention": [
            1.625,
            0.475,
            0.9125
        ],
        "dimentionText": [
            "65\"",
            "19\"",
            "36.5\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Vast Sky",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Addy Double Dresser 65.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 133,
        "title": "Sanibel Counter Stool - Natural",
        "uuid": 133,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -5,
            1.25,
            10
        ],
        "product": "Sanibel_counter_stool_natural",
        "dimention": [
            0.3875,
            0.3875,
            0.6
        ],
        "dimentionText": [
            "15.5\"",
            "15.5\"",
            "24\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "chairFrameFinish": {
                    "default": "Natural Maple",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            0,
            5
        ],
        "variant": null,
        "modelLink": "models/Sanibel Counter Stool - Natural.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 152,
        "title": "Addy Bedside Cabinet",
        "uuid": 152,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -0.94,
            0.61,
            1.94
        ],
        "product": "Addy_bedside_cabinet",
        "dimention": [
            0.575,
            0.475,
            0.8
        ],
        "dimentionText": [
            "23\"",
            "19\"",
            "32\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": "Left",
        "modelLink": "models/Addy Bedside Cabinet_left.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 169,
        "title": "Big Cay Desk with Library Hutch",
        "uuid": 169,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.9,
            0
        ],
        "cameraInitPos": [
            -2.24,
            0.91,
            3.71
        ],
        "product": "Big_cay_desk_with_library_hutch",
        "dimention": [
            1.625,
            0.6,
            1.775
        ],
        "dimentionText": [
            "65\"",
            "24\"",
            "71\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Surf",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "woodTopFinish": {
                    "default": "Painted",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Big Cay Desk with Library Hutch.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 145,
        "title": "Inga Trestle Dining Table",
        "uuid": 145,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -2.05,
            1.05,
            3.11
        ],
        "product": "Inga_trestle_dining_table",
        "dimention": [
            1.8,
            1.05,
            0.75
        ],
        "dimentionText": [
            "72\"",
            "42\"",
            "30\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "woodTopFinish": {
                    "default": "Painted",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            3.5
        ],
        "variant": "Seats 4",
        "modelLink": "models/Inga Trestle Dining Table_4.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 131,
        "title": "Judy Dining Chair - Painted",
        "uuid": 131,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.4,
            0
        ],
        "cameraInitPos": [
            -5,
            1.25,
            10
        ],
        "product": "Judy_dining_chair_painted",
        "dimention": [
            0.5625,
            0.5375,
            0.775
        ],
        "dimentionText": [
            "22.5\"",
            "21.5\"",
            "31\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "cushionFinish": {
                    "default": "No Cushion",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.25
        ],
        "variant": null,
        "modelLink": "models/Judy Dining Chair - Painted.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 153,
        "title": "Addy Blanket Chest",
        "uuid": 153,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.22,
            0.5,
            1.95
        ],
        "product": "Addy_blanket_chest",
        "dimention": [
            0.95,
            0.475,
            0.625
        ],
        "dimentionText": [
            "38\"",
            "19\"",
            "25\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Addy Blanket Chest.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 191,
        "title": "Fiddlehead End Table",
        "uuid": 191,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -0.94,
            0.61,
            1.94
        ],
        "product": "Fiddlehead_end_table",
        "dimention": [
            0.8,
            0.625,
            0.625
        ],
        "dimentionText": [
            "32\"",
            "25\"",
            "25\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Fiddlehead End Table.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 181,
        "title": "Addy Side Table",
        "uuid": 181,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -0.94,
            0.61,
            1.94
        ],
        "product": "Addy_side_table",
        "dimention": [
            0.5,
            0.5,
            0.75
        ],
        "dimentionText": [
            "20\"",
            "20\"",
            "30\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Addy Side Table.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 192,
        "title": "Island Bedside Cabinet",
        "uuid": 192,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -0.94,
            0.61,
            1.94
        ],
        "product": "Island_bedside_cabinet",
        "dimention": [
            0.5,
            0.35,
            0.765
        ],
        "dimentionText": [
            "20\"",
            "14\"",
            "31\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": "Left",
        "modelLink": "models/Island Bedside Cabinet_left.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 130,
        "title": "Judy Dining Chair - Natural",
        "uuid": 130,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.4,
            0
        ],
        "cameraInitPos": [
            -0.57,
            0.45,
            1.59
        ],
        "product": "Judy_dining_chair_natural",
        "dimention": [
            0.5625,
            0.5675,
            0.775
        ],
        "dimentionText": [
            "22.5\"",
            "21.5\"",
            "31\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "chairFrameFinish": {
                    "default": "Natural Maple",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "cushionFinish": {
                    "default": "No Cushion",
                    "reapeatFactor": [
                        1.25,
                        1.25
                    ],
                    "offsetFactor": [
                        0.14,
                        2.4
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.25
        ],
        "variant": null,
        "modelLink": "models/Judy Dining Chair - Natural.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 125,
        "title": "Jack Counter Stool",
        "uuid": 125,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -5,
            1.25,
            10
        ],
        "product": "Jack_counter_stool",
        "dimention": [
            0.5,
            0.6375,
            1.2125
        ],
        "dimentionText": [
            "20\"",
            "25.5\"",
            "48.5\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Thatch : Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "legFinish": {
                    "default": "Nordic",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            0,
            5
        ],
        "variant": null,
        "modelLink": "models/Jack Counter Stool 1.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 137,
        "title": "Windsor Dining Chair - Natural",
        "uuid": 137,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -5,
            1.25,
            10
        ],
        "product": "Windsor_dining_chair_natural",
        "dimention": [
            0.525,
            0.56875,
            0.99375
        ],
        "dimentionText": [
            "21\"",
            "22.75\"",
            "39.75\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "chairFrameFinish": {
                    "default": "Natural Maple",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "cushionFinish": {
                    "default": "No Cushion",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            0,
            5
        ],
        "variant": null,
        "modelLink": "models/Windsor Dining Chair - Natural.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 138,
        "title": "Windsor Dining Chair - Painted",
        "uuid": 138,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.4,
            0
        ],
        "cameraInitPos": [
            -0.57,
            0.45,
            1.59
        ],
        "product": "Windsor_dining_chair_painted",
        "dimention": [
            0.525,
            0.56875,
            0.99375
        ],
        "dimentionText": [
            "21\"",
            "22.75\"",
            "39.75\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "cushionFinish": {
                    "default": "No Cushion",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        -0.13,
                        0.24
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.25
        ],
        "variant": null,
        "modelLink": "models/Windsor Dining Chair - Painted.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 186,
        "title": "Cast-a-Net Stool",
        "uuid": 186,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.1,
            0
        ],
        "cameraInitPos": [
            -1.22,
            0.5,
            1.95
        ],
        "product": "Castanet_stool",
        "dimention": [
            0.475,
            0.425,
            0.425
        ],
        "dimentionText": [
            "19\"",
            "17\"",
            "17\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Cast-a-Net Stool.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 224,
        "title": "Lattice Day Bed",
        "uuid": 224,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.72,
            0.61,
            3.45
        ],
        "product": "Lattice_day_bed",
        "dimention": [
            2.025,
            1.068,
            1.025
        ],
        "dimentionText": [
            "81\"",
            "42.75\"",
            "41\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Cloud",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Lattice Day Bed.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 223,
        "title": "Lattice Bed",
        "uuid": 223,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.8,
            0
        ],
        "cameraInitPos": [
            -2.94,
            0.83,
            4.52
        ],
        "product": "Lattice_bed",
        "dimention": [
            1.043,
            2,
            1.306
        ],
        "dimentionText": [
            "41.75\"",
            "80\"",
            "52.25\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1.5,
            5
        ],
        "variant": "Twin",
        "modelLink": "models/Lattice Bed Twin.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 204,
        "title": "Large Charlie Buffet",
        "uuid": 204,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.72,
            0.61,
            3.45
        ],
        "product": "Large_charlie_buffet",
        "dimention": [
            1.45,
            0.55,
            0.9
        ],
        "dimentionText": [
            "58\"",
            "22\"",
            "36\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Large Charlie Buffet.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 200,
        "title": "Charlie Media Console",
        "uuid": 200,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -1.45,
            0.75,
            2.38
        ],
        "product": "Charlie_media_console",
        "dimention": [
            1.2,
            0.375,
            1
        ],
        "dimentionText": [
            "48\"",
            "15\"",
            "40\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.8
        ],
        "variant": null,
        "modelLink": "models/Charlie Media Console.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 165,
        "title": "Nellie 2-Over-2-Dresser",
        "uuid": 165,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -1.45,
            0.75,
            2.38
        ],
        "product": "Nellie_2over2dresser",
        "dimention": [
            1,
            0.5,
            0.9
        ],
        "dimentionText": [
            "40\"",
            "20\"",
            "36\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.8
        ],
        "variant": null,
        "modelLink": "models/Nellie 2-Over-2-Dresser.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 193,
        "title": "Lottie Leaf Stool",
        "uuid": 193,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.1,
            0
        ],
        "cameraInitPos": [
            -1.22,
            0.5,
            1.95
        ],
        "product": "Lottie_leaf_stool",
        "dimention": [
            0.475,
            0.425,
            0.425
        ],
        "dimentionText": [
            "19\"",
            "17\"",
            "17\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Lottie Leaf Stool.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 187,
        "title": "Charlie Round Side Table",
        "uuid": 187,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.4,
            0
        ],
        "cameraInitPos": [
            -0.57,
            0.45,
            1.59
        ],
        "product": "Charlie_round_side_table",
        "dimention": [
            0.525,
            0.525,
            0.7
        ],
        "dimentionText": [
            "21\"",
            "21\"",
            "28\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.25
        ],
        "variant": null,
        "modelLink": "models/Charlie Round Side Table.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 207,
        "title": "Largest Stow-Away Shelf",
        "uuid": 207,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -1.45,
            0.55,
            2.38
        ],
        "product": "Largest_stowaway_shelf",
        "dimention": [
            1.175,
            0.35,
            1.65
        ],
        "dimentionText": [
            "47\"",
            "14\"",
            "66\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.8
        ],
        "variant": null,
        "modelLink": "models/Largest Stow-Away Shelf.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 189,
        "title": "Classic Cottage Sofa Table",
        "uuid": 189,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -0.94,
            0.61,
            1.94
        ],
        "product": "Classic_cottage_sofa_table",
        "dimention": [
            0.6,
            0.6,
            0.625
        ],
        "dimentionText": [
            "24\"",
            "24\"",
            "25\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Classic Cottage Sofa Table.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 206,
        "title": "Large Stow-Away Shelf",
        "uuid": 206,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.6,
            0.68,
            2.82
        ],
        "product": "Large_stowaway_shelf",
        "dimention": [
            1.55,
            0.35,
            0.975
        ],
        "dimentionText": [
            "62\"",
            "14\"",
            "39\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Large Stow-Away Shelf.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 210,
        "title": "Medium Stow-Away Shelf",
        "uuid": 210,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -1.45,
            0.75,
            2.38
        ],
        "product": "Medium_stowaway_shelf",
        "dimention": [
            1.175,
            0.35,
            0.975
        ],
        "dimentionText": [
            "47\"",
            "14\"",
            "39\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Porch",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.8
        ],
        "variant": null,
        "modelLink": "models/Medium Stow-Away Shelf.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 198,
        "title": "Wendy Side Table",
        "uuid": 198,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -0.94,
            0.61,
            1.94
        ],
        "product": "Wendy_side_table",
        "dimention": [
            0.5,
            0.5,
            0.65
        ],
        "dimentionText": [
            "20\"",
            "20\"",
            "26\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Lagoon",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Wendy Side Table.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 230,
        "title": "Hazel Chair",
        "uuid": 14,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.17,
            0.51,
            1.85
        ],
        "product": "Hazel_chair",
        "dimention": [
            0.725,
            0.8,
            0.825
        ],
        "dimentionText": [
            "29\"",
            "32\"",
            "33\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Thatch : Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0.06,
                        0.04
                    ]
                },
                "legFinish": {
                    "default": "Nordic",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.25
        ],
        "variant": "Stationary",
        "modelLink": "models/Hazel Chair_Stationary.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 188,
        "title": "Chesapeake End Table",
        "uuid": 188,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -0.94,
            0.61,
            1.94
        ],
        "product": "Chesapeake_end_table",
        "dimention": [
            0.45,
            0.45,
            0.65
        ],
        "dimentionText": [
            "18\"",
            "18\"",
            "26\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Chesapeake End Table.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 170,
        "title": "Cokie Desk Chair",
        "uuid": 170,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -5,
            1.25,
            10
        ],
        "product": "Cokie_desk_chair",
        "dimention": [
            0.6375,
            0.6875,
            0.95
        ],
        "dimentionText": [
            "25.5\"",
            "27.5\"",
            "38\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            0,
            5
        ],
        "variant": null,
        "modelLink": "models/Cokie Desk Chair.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 167,
        "title": "Nellie Double Dresser",
        "uuid": 167,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.72,
            0.61,
            3.45
        ],
        "product": "Nellie_double_dresser",
        "dimention": [
            1.6,
            0.5,
            0.9
        ],
        "dimentionText": [
            "64\"",
            "20\"",
            "36\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Nellie Double Dresser.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 202,
        "title": "Great Island Bookshelf",
        "uuid": 202,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.9,
            0
        ],
        "cameraInitPos": [
            -2.24,
            0.91,
            3.71
        ],
        "product": "Great_island_bookshelf",
        "dimention": [
            0.85,
            0.375,
            1.675
        ],
        "dimentionText": [
            "34\"",
            "15\"",
            "67\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Great Island Bookshelf.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 74,
        "title": "Stevie Ottoman",
        "uuid": 74,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -5,
            1.25,
            10
        ],
        "product": "Stevie_ottoman",
        "dimention": [
            0.75,
            0.55,
            0.462
        ],
        "dimentionText": [
            "30\"",
            "22\"",
            "18.5\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Thatch : Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "legFinish": {
                    "default": "Nordic",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            0,
            5
        ],
        "variant": null,
        "modelLink": "models/Stevie Ottoman.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 221,
        "title": "Jack Dining Chair",
        "uuid": 221,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -5,
            1.25,
            10
        ],
        "product": "Jack_dining_chair",
        "dimention": [
            0.5,
            0.6,
            0.962
        ],
        "dimentionText": [
            "20\"",
            "24\"",
            "38.5\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Thatch : Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        -0.06,
                        -0.07
                    ]
                },
                "legFinish": {
                    "default": "Nordic",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            0,
            5
        ],
        "variant": null,
        "modelLink": "models/Jack Dining Chair.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 63,
        "title": "Freya Bench",
        "uuid": 63,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -0.94,
            0.61,
            1.94
        ],
        "product": "Freya_bench",
        "dimention": [
            0.775,
            0.525,
            0.537
        ],
        "dimentionText": [
            "31\"",
            "21\"",
            "21.5\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Boomerang: Sage",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0.1,
                        -0.22
                    ]
                },
                "legFinish": {
                    "default": "Nordic",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Freya Bench.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 43,
        "title": "Elle Long Sofa",
        "uuid": 43,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.72,
            0.61,
            3.45
        ],
        "product": "Elle_long_sofa",
        "dimention": [
            2.35,
            0.925,
            0.825
        ],
        "dimentionText": [
            "94\"",
            "37\"",
            "33\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Shore-Bet : Nantucket",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0.36,
                        0.24
                    ]
                },
                "legFinish": {
                    "default": "Nordic",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Elle Long Sofa.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 197,
        "title": "Tide Pool Side Table",
        "uuid": 197,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -0.94,
            0.61,
            1.94
        ],
        "product": "Tide_pool_side_table",
        "dimention": [
            0.425,
            0.75,
            0.5
        ],
        "dimentionText": [
            "17\"",
            "30\"",
            "20\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Tide Pool Side Table.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 213,
        "title": "Small Island Bookshelf",
        "uuid": 213,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -0.94,
            0.61,
            1.94
        ],
        "product": "Small_island_bookshelf",
        "dimention": [
            1.075,
            0.375,
            0.975
        ],
        "dimentionText": [
            "43\"",
            "15\"",
            "39\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Small Island Bookshelf.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 268,
        "title": "Shutter Bed",
        "uuid": 93,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.8,
            0
        ],
        "cameraInitPos": [
            -2.94,
            0.83,
            4.52
        ],
        "product": "Shutter_bed",
        "dimention": [
            1.6,
            2.125,
            1.344
        ],
        "dimentionText": [
            "63.75\"",
            "85\"",
            "53\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bright White",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1.5,
            5
        ],
        "variant": "Queen",
        "modelLink": "models/Shutter Bed_Queen.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 212,
        "title": "Skinniest Island Bookshelf",
        "uuid": 212,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -1.45,
            0.75,
            2.38
        ],
        "product": "Skinniest_island_bookshelf",
        "dimention": [
            0.725,
            0.375,
            1.675
        ],
        "dimentionText": [
            "23\"",
            "15\"",
            "67\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.8
        ],
        "variant": null,
        "modelLink": "models/Skinniest Island Bookshelf.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 211,
        "title": "Ruby Sound Cabinet",
        "uuid": 211,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.13,
            0.5,
            2.27
        ],
        "product": "Ruby_sound_cabinet",
        "dimention": [
            1.175,
            0.525,
            0.65
        ],
        "dimentionText": [
            "47\"",
            "21\"",
            "26\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Ruby Sound Cabinet.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 263,
        "title": "Mabel Bed",
        "uuid": 90,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.8,
            0
        ],
        "cameraInitPos": [
            -2.94,
            0.83,
            4.52
        ],
        "product": "Mabel_bed",
        "dimention": [
            1.99,
            2.125,
            1.344
        ],
        "dimentionText": [
            "79.75\"",
            "86\"",
            "53.75\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ],
                    "default": "Oyster"
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1.5,
            5
        ],
        "variant": "King",
        "modelLink": "models/Mabel Bed_King.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 29,
        "title": "Tilly Chair",
        "uuid": 29,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.17,
            0.51,
            1.85
        ],
        "product": "Tilly_chair",
        "dimention": [
            0.725,
            0.625,
            0.95
        ],
        "dimentionText": [
            "29\"",
            "25\"",
            "38\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Oxford Stripe : Marine",
                    "reapeatFactor": [
                        1,
                        1.06
                    ],
                    "offsetFactor": [
                        -0.14,
                        0
                    ]
                },
                "legPaintColorFinish": {
                    "default": "Academy",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.25
        ],
        "variant": null,
        "modelLink": "models/Tilly Chair.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 217,
        "title": "Tall Stow-Away Shelf",
        "uuid": 217,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.8,
            0
        ],
        "cameraInitPos": [
            -2.08,
            0.8,
            3.42
        ],
        "product": "Tall_stowaway_shelf",
        "dimention": [
            0.8,
            0.35,
            1.65
        ],
        "dimentionText": [
            "32\"",
            "14\"",
            "66\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            6
        ],
        "variant": null,
        "modelLink": "models/Tall Stow-Away Shelf.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 244,
        "title": "High Tide Bed",
        "uuid": 85,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.8,
            0
        ],
        "cameraInitPos": [
            -2.94,
            0.83,
            4.52
        ],
        "product": "High_tide_bed",
        "dimention": [
            1.99,
            2.125,
            2
        ],
        "dimentionText": [
            "79.75\"",
            "88\"",
            "80\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Vast Sky",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1.5,
            5
        ],
        "variant": "King",
        "modelLink": "models/High Tide Bed_King.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 208,
        "title": "Margate Bookshelf with Doors",
        "uuid": 208,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.9,
            0
        ],
        "cameraInitPos": [
            -2.24,
            0.91,
            3.71
        ],
        "product": "Margate_bookshelf_with_doors",
        "dimention": [
            0.85,
            0.375,
            1.775
        ],
        "dimentionText": [
            "34\"",
            "15\"",
            "71\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Margate Bookshelf with Doors.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 54,
        "title": "Wilton Skirtless Sofa",
        "uuid": 54,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.72,
            0.61,
            3.45
        ],
        "product": "Wilton_skirtless_sofa",
        "dimention": [
            2.1,
            0.875,
            0.925
        ],
        "dimentionText": [
            "84\"",
            "35\"",
            "37\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Thatch : Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        -0.37,
                        -0.19
                    ]
                },
                "legFinish": {
                    "default": "Nordic",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Wilton Skirtless Sofa.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 61,
        "title": "Evy Ottoman",
        "uuid": 61,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -0.94,
            0.61,
            1.94
        ],
        "product": "Evy_ottoman",
        "dimention": [
            0.7,
            0.55,
            0.425
        ],
        "dimentionText": [
            "28\"",
            "22\"",
            "17\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Thatch : Bluebell",
                    "reapeatFactor": [
                        1.35,
                        1.35
                    ],
                    "offsetFactor": [
                        -0.01,
                        0.14
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Evy Ottoman.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 260,
        "title": "Island Bed",
        "uuid": 87,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.8,
            0
        ],
        "cameraInitPos": [
            -2.94,
            0.83,
            4.52
        ],
        "product": "Island_bed",
        "dimention": [
            1.99,
            2.125,
            1.275
        ],
        "dimentionText": [
            "79.75\"",
            "86\"",
            "51\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Sprout",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1.5,
            5
        ],
        "variant": "King",
        "modelLink": "models/Island Bed_King.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 270,
        "title": "Cable Lock Dining Bench",
        "uuid": 99,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -5,
            1.25,
            10
        ],
        "product": "Cable_lock_dining_bench",
        "dimention": [
            1.5,
            0.35,
            0.45
        ],
        "dimentionText": [
            "60\"",
            "14\"",
            "18\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "woodTopFinish": {
                    "default": "Painted",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            0,
            5
        ],
        "variant": "60",
        "modelLink": "models/Cable Lock Dining Bench_60.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 2,
        "title": "Signature Kidney Pillow",
        "uuid": 2,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.1,
            0
        ],
        "cameraInitPos": [
            -0.94,
            0.61,
            1.94
        ],
        "product": "Signature_kidney_pillow",
        "dimention": [
            0.485,
            0.1475,
            0.26
        ],
        "dimentionText": [
            "19\"",
            "6\"",
            "10\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Oxford Stripe : Marine",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        -0.14,
                        0.14
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Signature Kidney Pillow.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 203,
        "title": "Island Media Center",
        "uuid": 203,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -1.45,
            0.75,
            2.38
        ],
        "product": "Island_media_center",
        "dimention": [
            1.6,
            0.55,
            0.65
        ],
        "dimentionText": [
            "64\"",
            "22\"",
            "26\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.8
        ],
        "variant": null,
        "modelLink": "models/Island Media Center.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 253,
        "title": "Lattice Bed",
        "uuid": 223,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.8,
            0
        ],
        "cameraInitPos": [
            -2.94,
            0.83,
            4.52
        ],
        "product": "Lattice_bed",
        "dimention": [
            1.593,
            2,
            1.306
        ],
        "dimentionText": [
            "63.75\"",
            "80\"",
            "52.25\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1.5,
            5
        ],
        "variant": "Queen",
        "modelLink": "models/Lattice Bed Queen.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 252,
        "title": "Lattice Bed",
        "uuid": 223,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.8,
            0
        ],
        "cameraInitPos": [
            -2.94,
            0.83,
            4.52
        ],
        "product": "Lattice_bed",
        "dimention": [
            1.443,
            2,
            1.306
        ],
        "dimentionText": [
            "57.75\"",
            "80\"",
            "52.25\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1.5,
            5
        ],
        "variant": "Double",
        "modelLink": "models/Lattice Bed Double.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 60,
        "title": "Eloise Ottoman",
        "uuid": 60,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -0.94,
            0.61,
            1.94
        ],
        "product": "Eloise_ottoman",
        "dimention": [
            0.7,
            0.7,
            0.475
        ],
        "dimentionText": [
            "28\"",
            "28\"",
            "19\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Beach House Linen : Vast Sky",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "legFinish": {
                    "default": "Nordic",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Eloise Ottoman.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 225,
        "title": "Lattice Double Dresser",
        "uuid": 225,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.72,
            0.61,
            3.45
        ],
        "product": "Lattice_double_dresser",
        "dimention": [
            1.65,
            0.485,
            0.95
        ],
        "dimentionText": [
            "66\"",
            "19\"",
            "38\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Sage",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Lattice Double Dresser.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1.5,
        "homepage": true
    },
    {
        "id": 241,
        "title": "Eliza Cannonball Bed with Storage",
        "uuid": 84,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.8,
            0
        ],
        "cameraInitPos": [
            -2.94,
            0.83,
            4.52
        ],
        "product": "Eliza_cannonball_bed_with_storage",
        "dimention": [
            2,
            2.225,
            1.5
        ],
        "dimentionText": [
            "80\"",
            "89\"",
            "60\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1.5,
            5
        ],
        "variant": "King",
        "modelLink": "models/Eliza Cannonball Bed with Storage_KIng.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 236,
        "title": "Calvin Bed",
        "uuid": 82,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.8,
            0
        ],
        "cameraInitPos": [
            -2.94,
            0.83,
            4.52
        ],
        "product": "Calvin_bed",
        "dimention": [
            1.99,
            2.15,
            2
        ],
        "dimentionText": [
            "79.75\"",
            "86\"",
            "80\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Marine",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1.5,
            5
        ],
        "variant": "King",
        "modelLink": "models/Calvin Bed_King.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 243,
        "title": "High Tide Bed",
        "uuid": 85,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.8,
            0
        ],
        "cameraInitPos": [
            -2.94,
            0.83,
            4.52
        ],
        "product": "High_tide_bed",
        "dimention": [
            1.6,
            2.125,
            2
        ],
        "dimentionText": [
            "63.75\"",
            "85\"",
            "80\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Vast Sky",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1.5,
            5
        ],
        "variant": "Queen",
        "modelLink": "models/High Tide Bed_Queen.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 267,
        "title": "Shutter Bed",
        "uuid": 93,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.8,
            0
        ],
        "cameraInitPos": [
            -2.94,
            0.83,
            4.52
        ],
        "product": "Shutter_bed",
        "dimention": [
            1.44,
            2,
            1.344
        ],
        "dimentionText": [
            "57.75\"",
            "80\"",
            "53\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bright White",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1.5,
            5
        ],
        "variant": "Double",
        "modelLink": "models/Shutter Bed_Double.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 84,
        "title": "Eliza Cannonball Bed with Storage",
        "uuid": 84,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.8,
            0
        ],
        "cameraInitPos": [
            -2.94,
            0.83,
            4.52
        ],
        "product": "Eliza_cannonball_bed_with_storage",
        "dimention": [
            1.45,
            2.1,
            1.5
        ],
        "dimentionText": [
            "58\"",
            "84\"",
            "60\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1.5,
            5
        ],
        "variant": "Double",
        "modelLink": "models/Eliza Cannonball Bed with Storage_Double.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 279,
        "title": "Della Dining Table",
        "uuid": 143,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -2.05,
            1.05,
            3.11
        ],
        "product": "Della_dining_table",
        "dimention": [
            1.5,
            1.5,
            0.75
        ],
        "dimentionText": [
            "60\"",
            "60\"",
            "30\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "woodTopFinish": {
                    "default": "Painted",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            3.5
        ],
        "variant": "Seats 6",
        "modelLink": "models/Della Dining Table_6.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 251,
        "title": "Island Bedside Cabinet",
        "uuid": 192,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -5,
            1.25,
            10
        ],
        "product": "Island_bedside_cabinet",
        "dimention": [
            0.5,
            0.35,
            0.765
        ],
        "dimentionText": [
            "20\"",
            "14\"",
            "31\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            0,
            5
        ],
        "variant": "Right",
        "modelLink": "models/Island Bedside Cabinet_right.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 264,
        "title": "Meriweather Bed",
        "uuid": 91,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.8,
            0
        ],
        "cameraInitPos": [
            -2.94,
            0.83,
            4.52
        ],
        "product": "Meriweather_bed",
        "dimention": [
            1.44,
            2,
            1.344
        ],
        "dimentionText": [
            "57.75\"",
            "80\"",
            "53\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Sun",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1.5,
            5
        ],
        "variant": "Double",
        "modelLink": "models/Meriweather Bed_Double.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 150,
        "title": "Addy 3-Drawer Bedside Dresser",
        "uuid": 150,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -0.94,
            0.61,
            1.94
        ],
        "product": "Addy_3drawer_bedside_dresser",
        "dimention": [
            0.575,
            0.475,
            0.9
        ],
        "dimentionText": [
            "23\"",
            "19\"",
            "32\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Addy 3-Drawer Bedside Dresser.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 11,
        "title": "Gretchen Chair",
        "uuid": 11,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -0.49,
            0.55,
            2.18
        ],
        "product": "Gretchen_chair",
        "dimention": [
            0.825,
            0.825,
            0.775
        ],
        "dimentionText": [
            "33\"",
            "33\"",
            "31\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Laguna : Pear",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        -0.14,
                        0.25
                    ]
                },
                "legFinish": {
                    "default": "Nordic",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.25
        ],
        "variant": null,
        "modelLink": "models/Gretchen Chair.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 156,
        "title": "Addy Hideaway Dresser",
        "uuid": 156,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -1.45,
            0.75,
            2.38
        ],
        "product": "Addy_hideaway_dresser",
        "dimention": [
            1.4,
            0.475,
            1.2875
        ],
        "dimentionText": [
            "56\"",
            "19\"",
            "51.5\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.8
        ],
        "variant": null,
        "modelLink": "models/Addy Hideaway Dresser.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 1,
        "title": "Signature Cord Welt Pillow",
        "uuid": 1,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.2,
            0
        ],
        "cameraInitPos": [
            -0.94,
            0.61,
            1.94
        ],
        "product": "Signature_cord_welt_pillow",
        "dimention": [
            0.459,
            0.214,
            0.455
        ],
        "dimentionText": [
            "18\"",
            "8.5\"",
            "18\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Thatch : Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        -0.11,
                        0.34
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Signature Cord Welt Pillow.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 272,
        "title": "Cable Lock Dining Table",
        "uuid": 142,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -2.05,
            1.05,
            3.11
        ],
        "product": "Cable_lock_dining_table",
        "dimention": [
            1.05,
            2,
            0.75
        ],
        "dimentionText": [
            "42\"",
            "80\"",
            "30\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "woodTopFinish": {
                    "default": "Painted",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            3.5
        ],
        "variant": "Seats 6",
        "modelLink": "models/Cable Lock Dining Table_6.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 262,
        "title": "Mabel Bed",
        "uuid": 90,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.8,
            0
        ],
        "cameraInitPos": [
            -2.94,
            0.83,
            4.52
        ],
        "product": "Mabel_bed",
        "dimention": [
            1.6,
            2.125,
            1.344
        ],
        "dimentionText": [
            "63.75\"",
            "85\"",
            "53.75\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Oyster",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1.5,
            5
        ],
        "variant": "Queen",
        "modelLink": "models/Mabel Bed_Queen.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 234,
        "title": "Calvin Bed",
        "uuid": 82,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.8,
            0
        ],
        "cameraInitPos": [
            -2.94,
            0.83,
            4.52
        ],
        "product": "Calvin_bed",
        "dimention": [
            1.44,
            2,
            2
        ],
        "dimentionText": [
            "57.75\"",
            "80\"",
            "80\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Marine",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1.5,
            5
        ],
        "variant": "Double",
        "modelLink": "models/Calvin Bed_Double.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 258,
        "title": "Island Bed",
        "uuid": 87,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.8,
            0
        ],
        "cameraInitPos": [
            -2.94,
            0.83,
            4.52
        ],
        "product": "Island_bed",
        "dimention": [
            1.44,
            2,
            1.275
        ],
        "dimentionText": [
            "57.75\"",
            "80\"",
            "51\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Sprout",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1.5,
            5
        ],
        "variant": "Double",
        "modelLink": "models/Island Bed_Double.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 164,
        "title": "Hannah Blanket Chest",
        "uuid": 164,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.13,
            0.5,
            2.27
        ],
        "product": "Hannah_blanket_chest",
        "dimention": [
            0.85,
            0.4,
            0.45
        ],
        "dimentionText": [
            "34\"",
            "16\"",
            "18\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Hannah Blanket Chest.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 183,
        "title": "Amelia Side Table",
        "uuid": 183,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -0.94,
            0.61,
            1.94
        ],
        "product": "Amelia_side_table",
        "dimention": [
            0.425,
            0.5,
            0.75
        ],
        "dimentionText": [
            "17\"",
            "20\"",
            "30\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Vast Sky",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Amelia Side Table.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 271,
        "title": "Cable Lock Dining Bench",
        "uuid": 99,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -5,
            1.25,
            10
        ],
        "product": "Cable_lock_dining_bench",
        "dimention": [
            1.8,
            0.35,
            0.45
        ],
        "dimentionText": [
            "72\"",
            "14\"",
            "18\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "woodTopFinish": {
                    "default": "Painted",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            0,
            5
        ],
        "variant": "72",
        "modelLink": "models/Cable Lock Dining Bench_72.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 240,
        "title": "Eliza Cannonball Bed with Storage",
        "uuid": 84,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.8,
            0
        ],
        "cameraInitPos": [
            -2.94,
            0.83,
            4.52
        ],
        "product": "Eliza_cannonball_bed_with_storage",
        "dimention": [
            1.6,
            2.225,
            1.5
        ],
        "dimentionText": [
            "64\"",
            "89\"",
            "60\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Shortcake",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1.5,
            5
        ],
        "variant": "Queen",
        "modelLink": "models/Eliza Cannonball Bed with Storage_Queen.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 199,
        "title": "Bed Bin",
        "uuid": 199,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.1,
            0
        ],
        "cameraInitPos": [
            -1.22,
            0.5,
            1.95
        ],
        "product": "Bed_bin",
        "dimention": [
            0.787,
            0.787,
            0.263
        ],
        "dimentionText": [
            "31.5\"",
            "31.5\"",
            "10.5\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Bed Bin.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 176,
        "title": "Chesapeake Bench",
        "uuid": 176,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.13,
            0.5,
            2.27
        ],
        "product": "Chesapeake_bench",
        "dimention": [
            1.2,
            0.537,
            0.475
        ],
        "dimentionText": [
            "48\"",
            "21.5\"",
            "19\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Chesapeake Bench.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 157,
        "title": "Addy Lingerie Dresser",
        "uuid": 157,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -1.45,
            0.75,
            2.38
        ],
        "product": "Addy_lingerie_dresser",
        "dimention": [
            0.575,
            0.475,
            1.5
        ],
        "dimentionText": [
            "23\"",
            "19\"",
            "60\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.8
        ],
        "variant": null,
        "modelLink": "models/Addy Lingerie Dresser.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 185,
        "title": "Bloom Tea Table",
        "uuid": 185,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.4,
            0
        ],
        "cameraInitPos": [
            -0.57,
            0.45,
            1.59
        ],
        "product": "Bloom_tea_table",
        "dimention": [
            0.625,
            0.3,
            0.3
        ],
        "dimentionText": [
            "25\"",
            "12\"",
            "12\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.25
        ],
        "variant": null,
        "modelLink": "models/Bloom Tea Table.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 209,
        "title": "Margate Media Console",
        "uuid": 209,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -1.45,
            0.75,
            2.28
        ],
        "product": "Margate_media_console",
        "dimention": [
            1.194,
            0.475,
            1
        ],
        "dimentionText": [
            "47.75\"",
            "19\"",
            "40\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.8
        ],
        "variant": null,
        "modelLink": "models/Margate Media Console.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 201,
        "title": "Extra Large Stow-Away Shelf",
        "uuid": 201,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.9,
            0
        ],
        "cameraInitPos": [
            -2.24,
            0.91,
            3.71
        ],
        "product": "Extra_large_stowaway_shelf",
        "dimention": [
            1.175,
            0.35,
            1.3
        ],
        "dimentionText": [
            "47\"",
            "14\"",
            "52\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Extra Large Stow-Away Shelf.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 179,
        "title": "Margaret Bench",
        "uuid": 179,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.13,
            0.5,
            2.27
        ],
        "product": "Margaret_bench",
        "dimention": [
            1.1,
            0.5,
            0.875
        ],
        "dimentionText": [
            "44\"",
            "20\"",
            "35\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Margaret Bench.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 242,
        "title": "High Tide Bed",
        "uuid": 85,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.8,
            0
        ],
        "cameraInitPos": [
            -2.94,
            0.83,
            4.52
        ],
        "product": "High_tide_bed",
        "dimention": [
            1.44,
            2,
            2
        ],
        "dimentionText": [
            "57.75\"",
            "80\"",
            "80\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Vast Sky",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1.5,
            5
        ],
        "variant": "Double",
        "modelLink": "models/High Tide Bed_Double.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 117,
        "title": "Cokie Counter Stool - Painted",
        "uuid": 117,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.4,
            0
        ],
        "cameraInitPos": [
            -0.57,
            0.45,
            1.59
        ],
        "product": "Cokie_counter_stool_painted",
        "dimention": [
            0.5,
            0.55,
            1.025
        ],
        "dimentionText": [
            "20\"",
            "22\"",
            "41\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "cushionFinish": {
                    "default": "No Cushion",
                    "reapeatFactor": [
                        1.25,
                        1.25
                    ],
                    "offsetFactor": [
                        -0.16,
                        -0.23
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.25
        ],
        "variant": null,
        "modelLink": "models/Cokie Counter Stool - Painted.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 227,
        "title": "Lattice 3-Drawer Dresser",
        "uuid": 227,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -1.17,
            0.51,
            1.85
        ],
        "product": "Lattice_3drawer_dresser",
        "dimention": [
            0.95,
            0.485,
            0.95
        ],
        "dimentionText": [
            "38\"",
            "19\"",
            "38\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.25
        ],
        "variant": null,
        "modelLink": "models/Lattice 3-Drawer Dresser.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 259,
        "title": "Island Bed",
        "uuid": 87,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.8,
            0
        ],
        "cameraInitPos": [
            -2.94,
            0.83,
            4.52
        ],
        "product": "Island_bed",
        "dimention": [
            1.6,
            2.125,
            1.275
        ],
        "dimentionText": [
            "63.75\"",
            "85\"",
            "51\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Sprout",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1.5,
            5
        ],
        "variant": "Queen",
        "modelLink": "models/Island Bed_Queen.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 215,
        "title": "Small Stow-Away Shelf",
        "uuid": 215,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -0.94,
            0.61,
            1.94
        ],
        "product": "Small_stowaway_shelf",
        "dimention": [
            0.8,
            0.35,
            0.975
        ],
        "dimentionText": [
            "32\"",
            "14\"",
            "39\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Sun",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Small Stow-Away Shelf.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 184,
        "title": "Bay Bedside Cabinet",
        "uuid": 184,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -0.94,
            0.61,
            1.94
        ],
        "product": "Bay_bedside_cabnet",
        "dimention": [
            0.5,
            0.35,
            0.725
        ],
        "dimentionText": [
            "20\"",
            "14\"",
            "29\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": "Left",
        "modelLink": "models/Bay Bedside Cabinet_left.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 108,
        "title": "Low Tide Hall Table",
        "uuid": 108,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.6,
            0.68,
            2.82
        ],
        "product": "Low_tide_hall_table",
        "dimention": [
            1.575,
            0.35,
            0.9
        ],
        "dimentionText": [
            "63\"",
            "14\"",
            "36\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Vast Sky",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Low Tide Hall Table.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 166,
        "title": "Nellie 3-Drawer Dresser",
        "uuid": 166,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -1.45,
            0.75,
            2.38
        ],
        "product": "Nellie_3drawer_dresser",
        "dimention": [
            1,
            0.5,
            0.9
        ],
        "dimentionText": [
            "40\"",
            "20\"",
            "36\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.8
        ],
        "variant": null,
        "modelLink": "models/Nellie 3-Drawer Dresser.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 93,
        "title": "Shutter Bed",
        "uuid": 93,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.8,
            0
        ],
        "cameraInitPos": [
            -2.94,
            0.83,
            4.52
        ],
        "product": "Shutter_bed",
        "dimention": [
            1.05,
            2,
            1.3
        ],
        "dimentionText": [
            "42\"",
            "80\"",
            "53\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1.5,
            5
        ],
        "variant": "Twin",
        "modelLink": "models/Shutter Bed_Twin.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 205,
        "title": "Large Margate Buffet",
        "uuid": 205,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.6,
            0.68,
            2.82
        ],
        "product": "Large_margate_buffet",
        "dimention": [
            1.45,
            0.55,
            0.9
        ],
        "dimentionText": [
            "58\"",
            "22\"",
            "36\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Large Margate Buffet.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 190,
        "title": "Classic Maine Cottage End Table",
        "uuid": 190,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -0.94,
            0.61,
            1.94
        ],
        "product": "Classic_maine_cottage_end_table",
        "dimention": [
            0.475,
            0.55,
            0.7
        ],
        "dimentionText": [
            "19\"",
            "22\"",
            "28\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Classic Maine Cottage End Table.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 256,
        "title": "Lattice Bed",
        "uuid": 223,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.8,
            0
        ],
        "cameraInitPos": [
            -2.94,
            0.83,
            4.52
        ],
        "product": "Lattice_bed",
        "dimention": [
            2,
            2,
            1.306
        ],
        "dimentionText": [
            "79.75\"",
            "80\"",
            "52.25\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1.5,
            5
        ],
        "variant": "King",
        "modelLink": "models/Lattice Bed King.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 24,
        "title": "Oscar Chair",
        "uuid": 24,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.17,
            0.51,
            1.85
        ],
        "product": "Oscar_chair",
        "dimention": [
            0.725,
            0.9125,
            0.85
        ],
        "dimentionText": [
            "29\"",
            "36.5\"",
            "34\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Thatch : Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        -0.03,
                        0.28
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.25
        ],
        "variant": null,
        "modelLink": "models/Oscar Chair.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 196,
        "title": "Nellie End Table",
        "uuid": 196,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -0.94,
            0.61,
            1.94
        ],
        "product": "Nellie_end_table",
        "dimention": [
            0.55,
            0.5,
            0.75
        ],
        "dimentionText": [
            "22\"",
            "20\"",
            "30\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Nellie End Table.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 141,
        "title": "Breakers Extension Dining Table",
        "uuid": 141,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -2.05,
            1.05,
            3.11
        ],
        "product": "Breakers_extension_dining_table",
        "dimention": [
            2.3,
            1.1,
            0.75
        ],
        "dimentionText": [
            "72\" to 92\"",
            "40\"",
            "30\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "woodTopFinish": {
                    "default": "Painted",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            3.5
        ],
        "variant": "EXT 1",
        "modelLink": "models/Breakers Extension Dining Table_ext1.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 106,
        "title": "Lottie Leaf Coffee Table",
        "uuid": 106,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.1,
            0
        ],
        "cameraInitPos": [
            -0.68,
            0.62,
            2.05
        ],
        "product": "Lottie_leaf_coffee_table",
        "dimention": [
            1.3,
            1.3,
            0.475
        ],
        "dimentionText": [
            "52\"",
            "52\"",
            "19\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "woodTopFinish": {
                    "default": "Painted",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1.5,
            5
        ],
        "variant": null,
        "modelLink": "models/Lottie Leaf Coffee Table.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 101,
        "title": "Cable Lock Hall Table",
        "uuid": 101,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -5,
            1.25,
            10
        ],
        "product": "Cable_lock_hall_table",
        "dimention": [
            1.5,
            0.4,
            0.725
        ],
        "dimentionText": [
            "60\"",
            "16\"",
            "29\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "woodTopFinish": {
                    "default": "Painted",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            0,
            5
        ],
        "variant": null,
        "modelLink": "models/Cable Lock Hall Table.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 146,
        "title": "Lottie Leaf Dining Table",
        "uuid": 146,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -2.05,
            1.05,
            3.11
        ],
        "product": "Lottie_leaf_dining_table",
        "dimention": [
            1.9,
            1.05,
            0.75
        ],
        "dimentionText": [
            "76\"",
            "42\"",
            "30\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "woodTopFinish": {
                    "default": "Painted",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            3.5
        ],
        "variant": null,
        "modelLink": "models/Lottie Leaf Dining Table.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 58,
        "title": "Daphne Ottoman",
        "uuid": 58,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -0.94,
            0.61,
            1.94
        ],
        "product": "Daphne_ottoman",
        "dimention": [
            0.625,
            0.5,
            0.45
        ],
        "dimentionText": [
            "25\"",
            "20\"",
            "18\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Thatch : Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0.1,
                        -0.28
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Daphne Ottoman.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 99,
        "title": "Cable Lock Dining Bench",
        "uuid": 99,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -5,
            1.25,
            10
        ],
        "product": "Cable_lock_dining_bench",
        "dimention": [
            1.2,
            0.35,
            0.45
        ],
        "dimentionText": [
            "48\"",
            "14\"",
            "18\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "woodTopFinish": {
                    "default": "Painted",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            0,
            5
        ],
        "variant": "48",
        "modelLink": "models/Cable Lock Dining Bench_48.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 276,
        "title": "Breakers Extension Dining Table",
        "uuid": 141,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -2.05,
            1.05,
            3.11
        ],
        "product": "Breakers_extension_dining_table",
        "dimention": [
            2.75,
            1.1,
            0.75
        ],
        "dimentionText": [
            "72\" to 110\"",
            "40\"",
            "30\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "woodTopFinish": {
                    "default": "Painted",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            3.5
        ],
        "variant": "EXT 2",
        "modelLink": "models/Breakers Extension Dining Table_ext2.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 70,
        "title": "Ruben Hassock",
        "uuid": 70,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -0.94,
            0.61,
            1.94
        ],
        "product": "Ruben_hassock",
        "dimention": [
            0.55,
            0.55,
            0.375
        ],
        "dimentionText": [
            "22\"",
            "22\"",
            "15\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Clambake: Marine",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0.01,
                        0.41
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Ruben Hassock.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 77,
        "title": "Tulla Tuffet Ottoman",
        "uuid": 77,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.1,
            0
        ],
        "cameraInitPos": [
            -1.22,
            0.5,
            1.95
        ],
        "product": "Tulla_tuffet_ottoman",
        "dimention": [
            0.425,
            0.425,
            0.425
        ],
        "dimentionText": [
            "17\"",
            "17\"",
            "17\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Crazy Daisy : Wild Salmon",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0.11,
                        -0.24
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Tulla Tuffet Ottoman.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 218,
        "title": "Trundle Bed",
        "uuid": 218,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.8,
            0
        ],
        "cameraInitPos": [
            -2.94,
            0.83,
            4.52
        ],
        "product": "Trundle_bed",
        "dimention": [
            0.962,
            1.775,
            0.237
        ],
        "dimentionText": [
            "38.5\"",
            "71\"",
            "9.5\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1.5,
            5
        ],
        "variant": null,
        "modelLink": "models/Trundle Bed.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 17,
        "title": "Lilah Swivel Chair",
        "uuid": 17,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.17,
            0.51,
            1.85
        ],
        "product": "Lilah_swivel_chair",
        "dimention": [
            0.775,
            0.95,
            0.95
        ],
        "dimentionText": [
            "31\"",
            "38\"",
            "38\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Thatch : Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        -0.15,
                        0.23
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.25
        ],
        "variant": null,
        "modelLink": "models/Lilah Swivel Chair.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 269,
        "title": "Shutter Bed",
        "uuid": 93,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.8,
            0
        ],
        "cameraInitPos": [
            -2.94,
            0.83,
            4.52
        ],
        "product": "Shutter_bed",
        "dimention": [
            1.99,
            2.125,
            1.344
        ],
        "dimentionText": [
            "79.75\"",
            "86\"",
            "53\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bright White",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1.5,
            5
        ],
        "variant": "King",
        "modelLink": "models/Shutter Bed_King.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 235,
        "title": "Calvin Bed",
        "uuid": 82,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.8,
            0
        ],
        "cameraInitPos": [
            -2.94,
            0.83,
            4.52
        ],
        "product": "Calvin_bed",
        "dimention": [
            1.59,
            2.12,
            2
        ],
        "dimentionText": [
            "63.75\"",
            "85\"",
            "80\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Marine",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1.5,
            5
        ],
        "variant": "Queen",
        "modelLink": "models/Calvin Bed_Queen.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 265,
        "title": "Meriweather Bed",
        "uuid": 91,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.8,
            0
        ],
        "cameraInitPos": [
            -2.94,
            0.83,
            4.52
        ],
        "product": "Meriweather_bed",
        "dimention": [
            1.6,
            2.125,
            1.344
        ],
        "dimentionText": [
            "63.75\"",
            "85\"",
            "53\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Sun",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1.5,
            5
        ],
        "variant": "Queen",
        "modelLink": "models/Meriweather Bed_Queen.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 216,
        "title": "Smallest Island Bookshelf",
        "uuid": 216,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -0.94,
            0.61,
            1.94
        ],
        "product": "Smallest_island_bookshelf",
        "dimention": [
            0.575,
            0.375,
            0.975
        ],
        "dimentionText": [
            "23\"",
            "15\"",
            "39\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Smallest Island Bookshelf.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 122,
        "title": "Edna Dining Chair - Natural",
        "uuid": 122,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -5,
            1.25,
            10
        ],
        "product": "Edna_dining_chair_natural",
        "dimention": [
            0.48125,
            0.5,
            0.925
        ],
        "dimentionText": [
            "19.25\"",
            "20\"",
            "37\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "chairFrameFinish": {
                    "default": "Natural Maple",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "cushionFinish": {
                    "default": "No Cushion",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            0,
            5
        ],
        "variant": null,
        "modelLink": "models/Edna Dining Chair - Natural.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 173,
        "title": "Low Tide Desk",
        "uuid": 173,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -2.05,
            1.05,
            3.11
        ],
        "product": "Low_tide_desk",
        "dimention": [
            1.375,
            0.55,
            0.775
        ],
        "dimentionText": [
            "55\"",
            "22\"",
            "31\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Marine",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "woodTopFinish": {
                    "default": "Painted",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            3.5
        ],
        "variant": null,
        "modelLink": "models/Low Tide Desk.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 222,
        "title": "Jill Dining Chair",
        "uuid": 222,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -5,
            1.25,
            10
        ],
        "product": "Jill_dining_chair",
        "dimention": [
            0.575,
            0.675,
            0.95
        ],
        "dimentionText": [
            "23\"",
            "27\"",
            "38\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Boats By The Yard : Gladiola",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        -0.14,
                        0.11
                    ]
                },
                "legFinish": {
                    "default": "Nordic",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            0,
            5
        ],
        "variant": null,
        "modelLink": "models/Jill Dining Chair.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 124,
        "title": "Ida Swivel Counter Stool",
        "uuid": 124,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.4,
            0
        ],
        "cameraInitPos": [
            -0.57,
            0.45,
            1.59
        ],
        "product": "Ida_swivel_counter_stool",
        "dimention": [
            0.5,
            0.5625,
            1.1
        ],
        "dimentionText": [
            "20\"",
            "22.5\"",
            "44\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Sea Biscuit : Porch",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        -0.14,
                        -0.02
                    ]
                },
                "legFinish": {
                    "default": "Nordic",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.25
        ],
        "variant": null,
        "modelLink": "models/Ida Swivel Counter Stool.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 97,
        "title": "Boat Hull Hall Table",
        "uuid": 97,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.1,
            0
        ],
        "cameraInitPos": [
            -0.68,
            0.62,
            2.05
        ],
        "product": "Boat_hull_hall_table",
        "dimention": [
            1.393,
            0.525,
            0.525
        ],
        "dimentionText": [
            "55.75\"",
            "21\"",
            "21\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "woodTopFinish": {
                    "default": "Natural Maple",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1.5,
            5
        ],
        "variant": null,
        "modelLink": "models/Boat Hull Hall Table.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 172,
        "title": "Lottie Leaf Writing Desk",
        "uuid": 172,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -2.05,
            1.05,
            3.11
        ],
        "product": "Lottie_leaf_writing_desk",
        "dimention": [
            1.625,
            0.6,
            0.75
        ],
        "dimentionText": [
            "65\"",
            "24\"",
            "30\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "woodTopFinish": {
                    "default": "Painted",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            3.5
        ],
        "variant": null,
        "modelLink": "models/Lottie Leaf Writing Desk.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 55,
        "title": "Jack Dining Chair",
        "uuid": 55,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.4,
            0
        ],
        "cameraInitPos": [
            -0.57,
            0.45,
            1.59
        ],
        "product": "Jack_dining_chair",
        "dimention": [
            0.5,
            0.6,
            0.962
        ],
        "dimentionText": [
            "20\"",
            "24\"",
            "38.5\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Clambake: Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        -0.05,
                        -0.07
                    ]
                },
                "legFinish": {
                    "default": "Nordic",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.25
        ],
        "variant": null,
        "modelLink": "models/Jack Dining Chair.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 139,
        "title": "Breakers Card Table",
        "uuid": 139,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -2.05,
            1.05,
            3.11
        ],
        "product": "Breakers_card_table",
        "dimention": [
            1.16,
            1.16,
            0.75
        ],
        "dimentionText": [
            "46\"",
            "46\"",
            "30\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "woodTopFinish": {
                    "default": "Painted",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            3.5
        ],
        "variant": null,
        "modelLink": "models/Breakers Card Table.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 12,
        "title": "Hailey Swivel Chair",
        "uuid": 12,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.17,
            0.51,
            1.85
        ],
        "product": "Hailey_swivel_chair",
        "dimention": [
            0.75,
            0.9375,
            0.7875
        ],
        "dimentionText": [
            "30\"",
            "37.5\"",
            "31.5\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Thatch : Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        -0.13,
                        0.12
                    ]
                },
                "legFinish": {
                    "default": "Nordic",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.25
        ],
        "variant": null,
        "modelLink": "models/Hailey Swivel Chair.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 148,
        "title": "Margate Extension Dining Table",
        "uuid": 148,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -2.05,
            1.05,
            3.11
        ],
        "product": "Margate_extension_dining_table",
        "dimention": [
            2.336,
            1.1,
            0.75
        ],
        "dimentionText": [
            "72\" to 92\"",
            "44\"",
            "30\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "woodTopFinish": {
                    "default": "Painted",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            3.5
        ],
        "variant": "EXT 1",
        "modelLink": "models/Margate Extension Dining Table_ext1.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 56,
        "title": "Jill Dining Chair",
        "uuid": 56,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.4,
            0
        ],
        "cameraInitPos": [
            -0.57,
            0.45,
            1.59
        ],
        "product": "Jill_dining_chair",
        "dimention": [
            0.575,
            0.675,
            0.95
        ],
        "dimentionText": [
            "23\"",
            "27\"",
            "38\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Boats By The Yard : Gladiola",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        -0.14,
                        0.22
                    ]
                },
                "legFinish": {
                    "default": "Nordic",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.25
        ],
        "variant": null,
        "modelLink": "models/Jill Dining Chair.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 95,
        "title": "Blanche Oval Coffee Table with Scallops",
        "uuid": 95,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.1,
            0
        ],
        "cameraInitPos": [
            -0.68,
            0.62,
            2.05
        ],
        "product": "Blanche_oval_coffee_table_with_scallops",
        "dimention": [
            1.2,
            0.75,
            0.475
        ],
        "dimentionText": [
            "48\"",
            "30\"",
            "19\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Sage",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "woodTopFinish": {
                    "default": "Painted",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1.5,
            5
        ],
        "variant": null,
        "modelLink": "models/Blanche Oval Coffee Table with Scallops.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 110,
        "title": "Topper Coffee Table",
        "uuid": 110,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.1,
            0
        ],
        "cameraInitPos": [
            -0.68,
            0.62,
            2.05
        ],
        "product": "Topper_coffee_table",
        "dimention": [
            1.15,
            1.15,
            0.475
        ],
        "dimentionText": [
            "46\"",
            "46\"",
            "19\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "woodTopFinish": {
                    "default": "Natural Maple",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1.5,
            5
        ],
        "variant": null,
        "modelLink": "models/Topper Coffee Table.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 143,
        "title": "Della Dining Table",
        "uuid": 143,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -2.05,
            1.05,
            3.11
        ],
        "product": "Della_dining_table",
        "dimention": [
            0.9,
            0.9,
            0.75
        ],
        "dimentionText": [
            "36\"",
            "36\"",
            "30\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "woodTopFinish": {
                    "default": "Painted",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            3.5
        ],
        "variant": "Bistro",
        "modelLink": "models/Della Dining Table_bistro.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 280,
        "title": "Inga Trestle Dining Table",
        "uuid": 145,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -2.05,
            1.05,
            3.11
        ],
        "product": "Inga_trestle_dining_table",
        "dimention": [
            2.1,
            1.1,
            0.75
        ],
        "dimentionText": [
            "84\"",
            "44\"",
            "30\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "woodTopFinish": {
                    "default": "Painted",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            3.5
        ],
        "variant": "Seats 6",
        "modelLink": "models/Inga Trestle Dining Table_6.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 261,
        "title": "Mabel Bed",
        "uuid": 90,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.8,
            0
        ],
        "cameraInitPos": [
            -2.94,
            0.83,
            4.52
        ],
        "product": "Mabel_bed",
        "dimention": [
            1.44,
            2,
            1.344
        ],
        "dimentionText": [
            "57.75\"",
            "80\"",
            "53.75\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Oyster",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1.5,
            5
        ],
        "variant": "Double",
        "modelLink": "models/Mabel Bed_Double.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 15,
        "title": "Henry Chair",
        "uuid": 15,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.17,
            0.51,
            1.85
        ],
        "product": "Henry_chair",
        "dimention": [
            0.687,
            0.875,
            0.85
        ],
        "dimentionText": [
            "27.5\"",
            "35\"",
            "34\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Thatch : Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0.11,
                        0.06
                    ]
                },
                "legFinish": {
                    "default": "Nordic",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.25
        ],
        "variant": "Stationary",
        "modelLink": "models/Henry Chair_Stationary.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 67,
        "title": "Mia Bench",
        "uuid": 67,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.13,
            0.5,
            2.27
        ],
        "product": "Mia_bench",
        "dimention": [
            1.175,
            0.737,
            0.462
        ],
        "dimentionText": [
            "47\"",
            "29.5\"",
            "18.5\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Thatch : Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        -0.12,
                        0.15
                    ]
                },
                "turnedLegFinish": {
                    "default": "Nordic",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Mia Bench.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 47,
        "title": "Harlow Wedge Sofa",
        "uuid": 47,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.72,
            0.61,
            3.45
        ],
        "product": "Harlow_wedge_sofa",
        "dimention": [
            2.1,
            0.95,
            0.95
        ],
        "dimentionText": [
            "84\"",
            "38\"",
            "38\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Oxford Stripe : Marine",
                    "reapeatFactor": [
                        2.5,
                        2.5
                    ],
                    "offsetFactor": [
                        0.16,
                        0
                    ]
                },
                "legFinish": {
                    "default": "Nordic",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Harlow Wedge Sofa.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 66,
        "title": "Lucy Ottoman",
        "uuid": 66,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -5,
            1.25,
            10
        ],
        "product": "Lucy_ottoman",
        "dimention": [
            0.675,
            0.525,
            0.437
        ],
        "dimentionText": [
            "27\"",
            "21\"",
            "17.5\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Thatch : Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        -0.21
                    ]
                },
                "legFinish": {
                    "default": "Nordic",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            0,
            5
        ],
        "variant": null,
        "modelLink": "models/Lucy Ottoman.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 19,
        "title": "Margot Chair",
        "uuid": 19,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.17,
            0.51,
            1.85
        ],
        "product": "Margot_chair",
        "dimention": [
            0.9,
            0.9,
            0.825
        ],
        "dimentionText": [
            "36\"",
            "36\"",
            "33\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Thatch : Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        -0.16,
                        0.18
                    ]
                },
                "turnedLegFinish": {
                    "default": "Nordic",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.25
        ],
        "variant": null,
        "modelLink": "models/Margot Chair.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 16,
        "title": "Hutton Chair",
        "uuid": 16,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -5,
            1.25,
            10
        ],
        "product": "Hutton_chair",
        "dimention": [
            0.875,
            0.975,
            0.875
        ],
        "dimentionText": [
            "35\"",
            "39\"",
            "35\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Boomerang: Sage",
                    "reapeatFactor": [
                        2,
                        2
                    ],
                    "offsetFactor": [
                        0.07,
                        0.26
                    ]
                },
                "legFinish": {
                    "default": "Nordic",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            0,
            5
        ],
        "variant": null,
        "modelLink": "models/Hutton Chair.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 248,
        "title": "Nina Chair",
        "uuid": 22,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -5,
            1.25,
            10
        ],
        "product": "Nina_chair",
        "dimention": [
            0.775,
            0.825,
            0.775
        ],
        "dimentionText": [
            "31\"",
            "33\"",
            "31\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Thatch : Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "legFinish": {
                    "default": "Nordic",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            0,
            5
        ],
        "variant": "Swivel",
        "modelLink": "models/Nina Chair_Swivel.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 114,
        "title": "Cokie Barstool - Natural",
        "uuid": 114,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -5,
            1.25,
            10
        ],
        "product": "Cokie_barstool_natural",
        "dimention": [
            0.5,
            0.55,
            1.125
        ],
        "dimentionText": [
            "20\"",
            "22\"",
            "45\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "chairFrameFinish": {
                    "default": "Natural Maple",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "cushionFinish": {
                    "default": "No Cushion",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            0,
            5
        ],
        "variant": null,
        "modelLink": "models/Cokie Barstool - Natural.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 22,
        "title": "Nina Chair",
        "uuid": 22,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -5,
            1.25,
            10
        ],
        "product": "Nina_chair",
        "dimention": [
            0.775,
            0.825,
            0.775
        ],
        "dimentionText": [
            "31\"",
            "33\"",
            "31\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Thatch : Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "legFinish": {
                    "default": "Nordic",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            0,
            5
        ],
        "variant": "Stationary",
        "modelLink": "models/Nina Chair_Stationary.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 85,
        "title": "High Tide Bed",
        "uuid": 85,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.8,
            0
        ],
        "cameraInitPos": [
            -2.94,
            0.83,
            4.52
        ],
        "product": "High_tide_bed",
        "dimention": [
            1.093,
            2,
            2
        ],
        "dimentionText": [
            "43.75\"",
            "80\"",
            "80\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Vast Sky",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1.5,
            5
        ],
        "variant": "Twin",
        "modelLink": "models/High Tide Bed_Twin.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 132,
        "title": "Minnie Counter Stool",
        "uuid": 132,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.4,
            0
        ],
        "cameraInitPos": [
            -0.57,
            0.45,
            1.59
        ],
        "product": "Minnie_counter_stool",
        "dimention": [
            0.45,
            0.375,
            0.775
        ],
        "dimentionText": [
            "18\"",
            "15\"",
            "31\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Thatch : Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0.12,
                        -0.21
                    ]
                },
                "legFinish": {
                    "default": "Nordic",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.25
        ],
        "variant": null,
        "modelLink": "models/Minnie Counter Stool.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 33,
        "title": "RETREAT - Monterey Chair",
        "uuid": 33,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.17,
            0.51,
            1.85
        ],
        "product": "Retreat_monterey_chair",
        "dimention": [
            0.937,
            1.037,
            0.937
        ],
        "dimentionText": [
            "37.5\"",
            "41.5\"",
            "37.5\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "retreatFabricFinish": {
                    "default": "Freckles : Skyline",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "retreatLegFinish": {
                    "default": "Sea Salt",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.25
        ],
        "variant": null,
        "modelLink": "models/Monterey Chair.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 45,
        "title": "Flora Wedge Sofa",
        "uuid": 45,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.72,
            0.61,
            3.45
        ],
        "product": "Flora_wedge_sofa_x",
        "dimention": [
            2.875,
            1.275,
            0.95
        ],
        "dimentionText": [
            "115\"",
            "51\"",
            "38\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Washed Out : Vast Sky",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        -0.13,
                        0.24
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            0,
            5
        ],
        "variant": null,
        "modelLink": "models/Flora Wedge Sofa - X.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 14,
        "title": "Hazel Chair",
        "uuid": 14,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.17,
            0.51,
            1.85
        ],
        "product": "Hazel_chair",
        "dimention": [
            0.725,
            0.8,
            0.825
        ],
        "dimentionText": [
            "29\"",
            "32\"",
            "33\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Thatch : Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        -0.08,
                        0.21
                    ]
                },
                "legFinish": {
                    "default": "Nordic",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.25
        ],
        "variant": "Swivel",
        "modelLink": "models/Hazel Chair_Swivel.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 231,
        "title": "Henry Chair",
        "uuid": 15,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.17,
            0.51,
            1.85
        ],
        "product": "Henry_chair",
        "dimention": [
            0.68725,
            0.875,
            0.85
        ],
        "dimentionText": [
            "27.5\"",
            "35\"",
            "34\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Thatch : Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0.25,
                        0.02
                    ]
                },
                "legFinish": {
                    "default": "Nordic",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.25
        ],
        "variant": "Swivel",
        "modelLink": "models/Henry Chair_Swivel.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 161,
        "title": "Charlotte 3 Drawer Dresser",
        "uuid": 161,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -1.45,
            0.75,
            2.38
        ],
        "product": "Charlotte_3_drawer_dresser",
        "dimention": [
            0.95,
            0.475,
            0.95
        ],
        "dimentionText": [
            "38\"",
            "19\"",
            "38\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "woodTopFinish": {
                    "default": "Painted",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.8
        ],
        "variant": "Painted Wood",
        "modelLink": "models/Charlotte 3 Drawer Dresser_wood.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 135,
        "title": "Windsor Arm Chair - Natural",
        "uuid": 135,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -5,
            1.25,
            10
        ],
        "product": "Windsor_arm_chair_natural",
        "dimention": [
            0.5875,
            0.5875,
            0.99375
        ],
        "dimentionText": [
            "23.5\"",
            "23.5\"",
            "39.75\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "chairFrameFinish": {
                    "default": "Natural Maple",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "cushionFinish": {
                    "default": "No Cushion",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            0,
            5
        ],
        "variant": null,
        "modelLink": "models/Windsor Arm Chair - Natural.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 59,
        "title": "Eleanor Ottoman",
        "uuid": 59,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -0.94,
            0.61,
            1.94
        ],
        "product": "Eleanor_ottoman",
        "dimention": [
            0.7,
            0.525,
            0.5
        ],
        "dimentionText": [
            "28\"",
            "21\"",
            "20\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Shore-Bet : Bermuda Beach",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0.11,
                        -0.27
                    ]
                },
                "legPaintColorFinish": {
                    "default": "Nordic",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Eleanor Ottoman.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 118,
        "title": "Cokie Desk Chair - Natural",
        "uuid": 118,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -5,
            1.25,
            10
        ],
        "product": "Cokie_desk_chair_natural",
        "dimention": [
            0.6375,
            0.6875,
            0.95
        ],
        "dimentionText": [
            "25.5\"",
            "27.5\"",
            "38\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "chairFrameFinish": {
                    "default": "Natural Maple",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "cushionFinish": {
                    "default": "No Cushion",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            0,
            5
        ],
        "variant": null,
        "modelLink": "models/Cokie Desk Chair - Natural.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 194,
        "title": "Lottie Side Table",
        "uuid": 194,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -0.94,
            0.61,
            1.94
        ],
        "product": "Lottie_side_table",
        "dimention": [
            0.625,
            0.5,
            0.75
        ],
        "dimentionText": [
            "25\"",
            "20\"",
            "30\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "woodTopFinish": {
                    "default": "Painted",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Lottie Side Table.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 239,
        "title": "Charlotte Bed",
        "uuid": 83,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.8,
            0
        ],
        "cameraInitPos": [
            -2.94,
            0.83,
            4.52
        ],
        "product": "Charlotte_bed",
        "dimention": [
            1.99,
            1.99,
            1.306
        ],
        "dimentionText": [
            "79.75\"",
            "79.5\"",
            "52.25\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Skyline",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "headboardFabricFinish": {
                    "default": "Freckles : Skyline",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1.5,
            5
        ],
        "variant": "King",
        "modelLink": "models/Charlotte Bed_King.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 140,
        "title": "Breakers Dining Table",
        "uuid": 140,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -5.1,
            1.95,
            7.9
        ],
        "product": "Breakers_dining_table",
        "dimention": [
            0.825,
            1.5,
            0.75
        ],
        "dimentionText": [
            "33\"",
            "60\"",
            "30\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "woodTopFinish": {
                    "default": "Painted",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            3.5
        ],
        "variant": "Seats 4",
        "modelLink": "models/Breakers Dining Table_4_Seat.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 25,
        "title": "Piper Chair",
        "uuid": 25,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.17,
            0.51,
            1.85
        ],
        "product": "Piper_chair",
        "dimention": [
            0.7625,
            0.75,
            1
        ],
        "dimentionText": [
            "30.5\"",
            "30\"",
            "40\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Thatch : Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0.36,
                        0.24
                    ]
                },
                "legFinish": {
                    "default": "Nordic",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.25
        ],
        "variant": null,
        "modelLink": "models/Piper Chair.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 249,
        "title": "Addy Bedside Cabinet",
        "uuid": 152,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -5,
            1.25,
            10
        ],
        "product": "Addy_bedside_cabinet",
        "dimention": [
            0.575,
            0.475,
            0.8
        ],
        "dimentionText": [
            "23\"",
            "19\"",
            "32\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Vast Sky",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            0,
            5
        ],
        "variant": "Right",
        "modelLink": "models/Addy Bedside Cabinet_right.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 86,
        "title": "High Tide Bunk Bed",
        "uuid": 86,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -5,
            1.25,
            10
        ],
        "product": "High_tide_bunk_bed",
        "dimention": [
            1.04375,
            2,
            1.825
        ],
        "dimentionText": [
            "41.75\"",
            "80\"",
            "73\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            0,
            5
        ],
        "variant": null,
        "modelLink": "models/High Tide Bunk Bed.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 238,
        "title": "Charlotte Bed",
        "uuid": 83,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.8,
            0
        ],
        "cameraInitPos": [
            -2.84,
            0.83,
            4.52
        ],
        "product": "Charlotte_bed",
        "dimention": [
            1.6,
            1.99,
            1.306
        ],
        "dimentionText": [
            "63.75\"",
            "79.5\"",
            "52.25\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Skyline",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "headboardFabricFinish": {
                    "default": "Freckles : Skyline",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1.5,
            5
        ],
        "variant": "Queen",
        "modelLink": "models/Charlotte Bed_Queen.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 220,
        "title": "Charlotte 3 Drawer Dresser",
        "uuid": 161,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -1.45,
            0.75,
            2.38
        ],
        "product": "Charlotte_3_drawer_dresser",
        "dimention": [
            0.95,
            0.475,
            0.95
        ],
        "dimentionText": [
            "38\"",
            "19\"",
            "38\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "woodTopFinish": {
                    "default": "Painted",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.8
        ],
        "variant": "Textured Silver",
        "modelLink": "models/Charlotte 3 Drawer Dresser_silver.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 69,
        "title": "Morgan Ottoman",
        "uuid": 69,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.13,
            0.5,
            2.27
        ],
        "product": "Morgan_ottoman",
        "dimention": [
            1.175,
            1.175,
            0.462
        ],
        "dimentionText": [
            "47\"",
            "47\"",
            "18.5\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Freckles : Skyline",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        -0.18,
                        0.21
                    ]
                },
                "turnedLegFinish": {
                    "default": "Nordic",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Morgan Ottoman.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 32,
        "title": "Winnie Chaise",
        "uuid": 32,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -5,
            1.25,
            10
        ],
        "product": "Winnie_chaise",
        "dimention": [
            0.75,
            1.6,
            0.9
        ],
        "dimentionText": [
            "30\"",
            "64\"",
            "36\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Thatch : Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "legFinish": {
                    "default": "Nordic",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            0,
            5
        ],
        "variant": null,
        "modelLink": "models/Winnie Chaise.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 113,
        "title": "Boothbay Dining Chair - Painted",
        "uuid": 113,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.4,
            0
        ],
        "cameraInitPos": [
            -0.57,
            0.45,
            1.59
        ],
        "product": "Boothbay_dining_chair_painted",
        "dimention": [
            0.475,
            0.5,
            0.85
        ],
        "dimentionText": [
            "19\"",
            "20\"",
            "34\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Sprout",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "cushionFinish": {
                    "default": "No Cushion",
                    "reapeatFactor": [
                        1.25,
                        1.25
                    ],
                    "offsetFactor": [
                        -0.16,
                        -0.06
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.25
        ],
        "variant": null,
        "modelLink": "models/Boothbay Dining Chair - Painted.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 36,
        "title": "RETREAT - Nantucket Chair and A Half Sleeper",
        "uuid": 36,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.63,
            0.62,
            3.09
        ],
        "product": "Retreat_nantucket_chair_and_a_half_sleeper",
        "dimention": [
            1.275,
            0.925,
            0.912
        ],
        "dimentionText": [
            "51\"",
            "37\"",
            "36.5\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "retreatFabricFinish": {
                    "default": "Beach House Linen : Vast Sky",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            3.5
        ],
        "variant": null,
        "modelLink": "models/Nantucket Chair & A Half Sleeper.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 82,
        "title": "Calvin Bed",
        "uuid": 82,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.8,
            0
        ],
        "cameraInitPos": [
            -2.94,
            0.83,
            4.52
        ],
        "product": "Calvin_bed",
        "dimention": [
            1.05,
            2,
            2
        ],
        "dimentionText": [
            "42\"",
            "80\"",
            "80\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1.5,
            5
        ],
        "variant": "Twin",
        "modelLink": "models/Calvin Bed_Twin.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 250,
        "title": "Bay Bedside Cabnet",
        "uuid": 184,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -5,
            1.25,
            10
        ],
        "product": "Bay_bedside_cabnet",
        "dimention": [
            0.5,
            0.35,
            0.725
        ],
        "dimentionText": [
            "20\"",
            "14\"",
            "29\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Vast Sky",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            0,
            5
        ],
        "variant": "Right",
        "modelLink": "models/Bay Bedside Cabinet_right.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 83,
        "title": "Charlotte Bed",
        "uuid": 83,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.8,
            0
        ],
        "cameraInitPos": [
            -2.94,
            0.83,
            4.52
        ],
        "product": "Charlotte_bed",
        "dimention": [
            1.043,
            1.99,
            1.306
        ],
        "dimentionText": [
            "41.75\"",
            "79.5\"",
            "52.25\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "headboardFabricFinish": {
                    "default": "Freckles : Skyline",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1.5,
            5
        ],
        "variant": "Twin",
        "modelLink": "models/Charlotte Bed_Twin.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 100,
        "title": "Cable Lock End Table",
        "uuid": 100,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -5,
            1.25,
            10
        ],
        "product": "Cable_lock_end_table",
        "dimention": [
            0.6,
            0.5,
            0.625
        ],
        "dimentionText": [
            "24\"",
            "20\"",
            "25\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "woodTopFinish": {
                    "default": "Painted",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            0,
            5
        ],
        "variant": null,
        "modelLink": "models/Cable Lock End Table.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 282,
        "title": "Margate Dining Table",
        "uuid": 147,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -2.05,
            1.05,
            3.11
        ],
        "product": "Margate_dining_table",
        "dimention": [
            2.1,
            1,
            0.75
        ],
        "dimentionText": [
            "84\"",
            "40\"",
            "30\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "woodTopFinish": {
                    "default": "Painted",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            3.5
        ],
        "variant": "Seats 8",
        "modelLink": "models/Margate Dining Table_8.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 266,
        "title": "Meriweather Bed",
        "uuid": 91,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.8,
            0
        ],
        "cameraInitPos": [
            -2.94,
            0.83,
            4.52
        ],
        "product": "Meriweather_bed",
        "dimention": [
            1.99,
            2.125,
            1.344
        ],
        "dimentionText": [
            "79.75\"",
            "86\"",
            "53\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Sun",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1.5,
            5
        ],
        "variant": "King",
        "modelLink": "models/Meriweather Bed_King.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 283,
        "title": "Margate Extension Dining Table",
        "uuid": 148,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -2.05,
            1.05,
            3.11
        ],
        "product": "Margate_extension_dining_table",
        "dimention": [
            2.8,
            1.1,
            0.75
        ],
        "dimentionText": [
            "72\" to 110\"",
            "44\"",
            "30\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "woodTopFinish": {
                    "default": "Painted",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            3.5
        ],
        "variant": "EXT 2",
        "modelLink": "models/Margate Extension Dining Table_ext2.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 27,
        "title": "Shelby Chair",
        "uuid": 27,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.17,
            0.51,
            1.85
        ],
        "product": "Shelby_chair",
        "dimention": [
            0.775,
            0.9,
            0.825
        ],
        "dimentionText": [
            "31\"",
            "36\"",
            "33\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Leaflette : Porch",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0.12,
                        -0.24
                    ]
                },
                "legFinish": {
                    "default": "Nordic",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.25
        ],
        "variant": null,
        "modelLink": "models/Shelby Chair.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 229,
        "title": "Charlotte 2-Over-3 Drawer Dresser",
        "uuid": 160,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -1.45,
            0.75,
            2.38
        ],
        "product": "Charlotte_2over3_drawer_dresser",
        "dimention": [
            0.95,
            0.475,
            1.125
        ],
        "dimentionText": [
            "38\"",
            "19\"",
            "45\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Zinnia",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "woodTopFinish": {
                    "default": "Painted",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.8
        ],
        "variant": "Textured Silver",
        "modelLink": "models/Charlotte 2-Over-3 Drawer Dresser silver.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 214,
        "title": "Small Margate Buffet",
        "uuid": 214,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.6,
            0.68,
            2.82
        ],
        "product": "Small_margate_buffet",
        "dimention": [
            1,
            0.55,
            0.9
        ],
        "dimentionText": [
            "40\"",
            "22\"",
            "36\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Small Margate Buffet.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 278,
        "title": "Della Dining Table",
        "uuid": 143,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -2.05,
            1.05,
            3.11
        ],
        "product": "Della_dining_table",
        "dimention": [
            1.2,
            1.2,
            0.75
        ],
        "dimentionText": [
            "48\"",
            "48\"",
            "30\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Vast Sky",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "woodTopFinish": {
                    "default": "Natural Maple",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            3.5
        ],
        "variant": "Seats 4",
        "modelLink": "models/Della Dining Table_4.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 126,
        "title": "Judy Bar Stool - Natural",
        "uuid": 126,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.4,
            0
        ],
        "cameraInitPos": [
            -0.57,
            0.45,
            1.59
        ],
        "product": "Judy_bar_stool_natural",
        "dimention": [
            0.51875,
            0.5,
            1.075
        ],
        "dimentionText": [
            "20.75\"",
            "20\"",
            "43\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "chairFrameFinish": {
                    "default": "Natural Maple",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "cushionFinish": {
                    "default": "No Cushion",
                    "reapeatFactor": [
                        1.25,
                        1.25
                    ],
                    "offsetFactor": [
                        0,
                        0.27
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.25
        ],
        "variant": null,
        "modelLink": "models/Judy Bar Stool - Natural.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 174,
        "title": "Bay Double Window Seat",
        "uuid": 174,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.72,
            0.61,
            3.45
        ],
        "product": "Bay_double_window_seat",
        "dimention": [
            1.55,
            0.5,
            0.45
        ],
        "dimentionText": [
            "62\"",
            "20\"",
            "18\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Sprout",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "cushionFinish": {
                    "default": "No Cushion",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Bay Double Window Seat.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 4,
        "title": "Barrett Bamboo Arm Chair",
        "uuid": 4,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.37,
            0
        ],
        "cameraInitPos": [
            -1.19,
            0.51,
            1.85
        ],
        "product": "Barrett_bamboo_arm_chair",
        "dimention": [
            0.575,
            0.575,
            0.9125
        ],
        "dimentionText": [
            "23\"",
            "23\"",
            "36.5\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Thatch : Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        -0.14,
                        0.2
                    ]
                },
                "legPaintColorFinish": {
                    "default": "Nordic",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.25
        ],
        "variant": null,
        "modelLink": "models/Barrett Bamboo Arm Chair.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 38,
        "title": "RETREAT - Monterey Sofa",
        "uuid": 38,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.72,
            0.61,
            3.45
        ],
        "product": "Retreat_monterey_sofa",
        "dimention": [
            2.225,
            1.037,
            0.937
        ],
        "dimentionText": [
            "89\"",
            "41.5\"",
            "37.5\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "retreatFabricFinish": {
                    "default": "Beach House Linen : Vast Sky",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "retreatLegFinish": {
                    "default": "Sea Salt",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            0,
            5
        ],
        "variant": null,
        "modelLink": "models/Nantucket Sofa.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 78,
        "title": "Wilton Skirted Ottoman",
        "uuid": 78,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -5,
            1.25,
            10
        ],
        "product": "Wilton_skirted_ottoman",
        "dimention": [
            0.65,
            0.4,
            0.475
        ],
        "dimentionText": [
            "26\"",
            "16\"",
            "19\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Thatch : Bluebell",
                    "reapeatFactor": [
                        1,
                        0.76
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            0,
            5
        ],
        "variant": null,
        "modelLink": "models/Wilton Skirted Ottoman.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 281,
        "title": "Margate Dining Table",
        "uuid": 147,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -2.05,
            1.05,
            3.11
        ],
        "product": "Margate_dining_table",
        "dimention": [
            1.9,
            0.9,
            0.75
        ],
        "dimentionText": [
            "72\"",
            "36\"",
            "30\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "woodTopFinish": {
                    "default": "Painted",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            3.5
        ],
        "variant": "Seats 6",
        "modelLink": "models/Margate Dining Table_6.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 273,
        "title": "Cable Lock Dining Table",
        "uuid": 142,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -2.05,
            1.05,
            3.11
        ],
        "product": "Cable_lock_dining_table",
        "dimention": [
            1.05,
            2.3,
            0.75
        ],
        "dimentionText": [
            "42\"",
            "92\"",
            "30\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "woodTopFinish": {
                    "default": "Painted",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            3.5
        ],
        "variant": "Seats 8",
        "modelLink": "models/Cable Lock Dining Table_8.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 76,
        "title": "Tilly Ottoman",
        "uuid": 76,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.1,
            0
        ],
        "cameraInitPos": [
            -1.22,
            0.5,
            1.95
        ],
        "product": "Tilly_ottoman",
        "dimention": [
            0.6,
            0.5,
            0.5
        ],
        "dimentionText": [
            "24\"",
            "20\"",
            "20\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Oxford Stripe : Marine",
                    "reapeatFactor": [
                        1,
                        1.17
                    ],
                    "offsetFactor": [
                        0.09,
                        0
                    ]
                },
                "legPaintColorFinish": {
                    "default": "Academy",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Tilly Ottoman.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 71,
        "title": "Paige Bench",
        "uuid": 71,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.13,
            0.5,
            2.27
        ],
        "product": "Paige_bench",
        "dimention": [
            0.913,
            0.525,
            0.6
        ],
        "dimentionText": [
            "36.5\"",
            "21\"",
            "24\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Sea Biscuit : Oyster",
                    "reapeatFactor": [
                        1,
                        1.1
                    ],
                    "offsetFactor": [
                        -0.13,
                        0
                    ]
                },
                "legFinish": {
                    "default": "Limewash",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Paige Bench.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 3,
        "title": "Astrid Chair",
        "uuid": 3,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.4,
            0
        ],
        "cameraInitPos": [
            -1.17,
            0.51,
            1.85
        ],
        "product": "Astrid_chair",
        "dimention": [
            0.825,
            0.825,
            0.775
        ],
        "dimentionText": [
            "33\"",
            "33\"",
            "31\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Thatch : Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        -0.15,
                        0.26
                    ]
                },
                "legFinish": {
                    "default": "Nordic",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.25
        ],
        "variant": null,
        "modelLink": "models/Astrid Chair.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 219,
        "title": "Charlotte Bedside Dresser",
        "uuid": 162,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -0.94,
            0.61,
            1.94
        ],
        "product": "Charlotte_bedside_dresser",
        "dimention": [
            0.75,
            0.475,
            0.75
        ],
        "dimentionText": [
            "30\"",
            "19\"",
            "30\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "woodTopFinish": {
                    "default": "Painted",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": "Painted Wood",
        "modelLink": "models/Charlotte Bedside Dresser_wood.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 168,
        "title": "Big Cay Desk",
        "uuid": 168,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -2.05,
            1.05,
            3.11
        ],
        "product": "Big_cay_desk",
        "dimention": [
            1.6,
            0.6,
            0.75
        ],
        "dimentionText": [
            "64\"",
            "24\"",
            "30\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Oyster",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "woodTopFinish": {
                    "default": "Painted",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            3.5
        ],
        "variant": null,
        "modelLink": "models/Big Cay Desk.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 233,
        "title": "Annie Bed",
        "uuid": 81,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.8,
            0
        ],
        "cameraInitPos": [
            -2.94,
            0.83,
            4.52
        ],
        "product": "Annie_bed",
        "dimention": [
            2,
            2.2,
            1.5
        ],
        "dimentionText": [
            "80\"",
            "88\"",
            "60\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Thatch : Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        -0.14,
                        0.16
                    ]
                },
                "legFinish": {
                    "default": "Nordic",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1.5,
            5
        ],
        "variant": "King",
        "modelLink": "models/Annie Bed_King.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 232,
        "title": "Annie Bed",
        "uuid": 81,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.8,
            0
        ],
        "cameraInitPos": [
            -2.94,
            0.83,
            4.52
        ],
        "product": "Annie_bed",
        "dimention": [
            1.6,
            2.2,
            1.5
        ],
        "dimentionText": [
            "64\"",
            "88\"",
            "60\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Shell Game : Marine",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0.11,
                        0.33
                    ]
                },
                "legFinish": {
                    "default": "Nordic",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1.5,
            5
        ],
        "variant": "Queen",
        "modelLink": "models/Annie Bed_Queen.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 160,
        "title": "Charlotte 2-Over-3 Drawer Dresser",
        "uuid": 160,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -1.45,
            0.75,
            2.38
        ],
        "product": "Charlotte_2over3_drawer_dresser",
        "dimention": [
            0.95,
            0.475,
            1.125
        ],
        "dimentionText": [
            "38\"",
            "19\"",
            "45\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "woodTopFinish": {
                    "default": "Painted",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.8
        ],
        "variant": "Painted Wood",
        "modelLink": "models/Charlotte 2-Over-3 Drawer Dresser wood.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 163,
        "title": "Charlotte Double Dresser",
        "uuid": 163,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.72,
            0.61,
            3.45
        ],
        "product": "Charlotte_double_dresser",
        "dimention": [
            1.65,
            0.475,
            0.95
        ],
        "dimentionText": [
            "66\"",
            "19\"",
            "38\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "woodTopFinish": {
                    "default": "Painted",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": "Painted Wood",
        "modelLink": "models/Charlotte Double Dresser_wood.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 274,
        "title": "Breakers Dining Table",
        "uuid": 140,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -5.1,
            1.95,
            7.9
        ],
        "product": "Breakers_dining_table",
        "dimention": [
            0.9,
            1.8,
            0.75
        ],
        "dimentionText": [
            "36\"",
            "72\"",
            "30\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Vast Sky",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "woodTopFinish": {
                    "default": "Painted",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            3.5
        ],
        "variant": "Seats 6",
        "modelLink": "models/Breakers Dining Table_6_Seat.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 81,
        "title": "Annie Bed",
        "uuid": 81,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.8,
            0
        ],
        "cameraInitPos": [
            -2.94,
            0.83,
            4.52
        ],
        "product": "Annie_bed",
        "dimention": [
            1.05,
            2.075,
            1.5
        ],
        "dimentionText": [
            "42\"",
            "83\"",
            "60\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Thatch : Bluebell",
                    "reapeatFactor": [
                        1,
                        1.07
                    ],
                    "offsetFactor": [
                        -0.14,
                        0
                    ]
                },
                "legFinish": {
                    "default": "Nordic",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1.5,
            5
        ],
        "variant": "Twin",
        "modelLink": "models/Annie Bed_Twin.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 257,
        "title": "Lucy Chair",
        "uuid": 18,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -5,
            1.25,
            10
        ],
        "product": "Lucy_chair",
        "dimention": [
            0.875,
            0.95,
            1
        ],
        "dimentionText": [
            "35\"",
            "38\"",
            "40\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Clambake: Bluebell",
                    "reapeatFactor": [
                        1.85,
                        1.85
                    ],
                    "offsetFactor": [
                        -0.34,
                        -0.68
                    ]
                },
                "legFinish": {
                    "default": "Nordic",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            0,
            5
        ],
        "variant": "Stationary",
        "modelLink": "models/Lucy Chair_Stationary.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 136,
        "title": "Windsor Arm Chair - Painted",
        "uuid": 136,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.4,
            0
        ],
        "cameraInitPos": [
            -0.57,
            0.45,
            1.59
        ],
        "product": "Windsor_arm_chair_painted",
        "dimention": [
            0.5875,
            0.5875,
            0.99375
        ],
        "dimentionText": [
            "23.5\"",
            "23.5\"",
            "39.75\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "cushionFinish": {
                    "default": "No Cushion",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        -0.15,
                        0.12
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.25
        ],
        "variant": null,
        "modelLink": "models/Windsor Arm Chair - Painted.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 96,
        "title": "Boat Hull Coffee Table",
        "uuid": 96,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.1,
            0
        ],
        "cameraInitPos": [
            -0.68,
            0.62,
            2.05
        ],
        "product": "Boat_hull_coffee_table",
        "dimention": [
            1.05,
            1.05,
            0.475
        ],
        "dimentionText": [
            "42\"",
            "42\"",
            "19\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "woodTopFinish": {
                    "default": "Natural Maple",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1.5,
            5
        ],
        "variant": null,
        "modelLink": "models/Boat Hull Coffee Table.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 151,
        "title": "Addy 4-Over-4-Drawer Dresser",
        "uuid": 151,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -1.45,
            0.75,
            2.38
        ],
        "product": "Addy_4over4drawer_dresser",
        "dimention": [
            0.95,
            0.475,
            1.55
        ],
        "dimentionText": [
            "38\"",
            "19\"",
            "62\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.8
        ],
        "variant": null,
        "modelLink": "models/Addy 4-Over-4-Drawer Dresser.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 162,
        "title": "Charlotte Bedside Dresser",
        "uuid": 162,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -0.94,
            0.61,
            1.94
        ],
        "product": "Charlotte_bedside_dresser",
        "dimention": [
            0.75,
            0.475,
            0.75
        ],
        "dimentionText": [
            "30\"",
            "19\"",
            "30\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "woodTopFinish": {
                    "default": "Painted",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": "Textured Silver",
        "modelLink": "models/Charlotte Bedside Dresser_silver.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 237,
        "title": "Charlotte Bed",
        "uuid": 83,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.8,
            0
        ],
        "cameraInitPos": [
            -2.94,
            0.83,
            4.52
        ],
        "product": "Charlotte_bed",
        "dimention": [
            1.44,
            1.99,
            1.306
        ],
        "dimentionText": [
            "57.75\"",
            "79.5\"",
            "52.25\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Skyline",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "headboardFabricFinish": {
                    "default": "Freckles : Skyline",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1.5,
            5
        ],
        "variant": "Double",
        "modelLink": "models/Charlotte Bed_Double.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 149,
        "title": "Addy 2-Over-3-Drawer Dresser",
        "uuid": 149,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -1.45,
            0.75,
            2.38
        ],
        "product": "Addy_2over3drawer_dresser",
        "dimention": [
            0.95,
            0.475,
            1.125
        ],
        "dimentionText": [
            "38\"",
            "19\"",
            "45\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.8
        ],
        "variant": null,
        "modelLink": "models/Addy 2-Over-3-Drawer Dresser.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 254,
        "title": "Little Cay Desk",
        "uuid": 171,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -5,
            1.25,
            10
        ],
        "product": "Little_cay_desk",
        "dimention": [
            1.193,
            0.6,
            0.75
        ],
        "dimentionText": [
            "47.75\"",
            "24\"",
            "30\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "woodTopFinish": {
                    "default": "Painted",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            0,
            5
        ],
        "variant": "Right",
        "modelLink": "models/Little Cay Desk_right.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 34,
        "title": "RETREAT - Monterey Barrel Back Swivel Chair",
        "uuid": 34,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.17,
            0.51,
            1.85
        ],
        "product": "Retreat_monterey_barrel_back_swivel_chair",
        "dimention": [
            0.887,
            1.05,
            0.937
        ],
        "dimentionText": [
            "35.5\"",
            "42\"",
            "37.5\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "retreatFabricFinish": {
                    "default": "Beach House Linen : Vast Sky",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.25
        ],
        "variant": null,
        "modelLink": "models/Monterey Barrel Back Swivel Chair.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 20,
        "title": "Max Chair",
        "uuid": 20,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.17,
            0.51,
            1.85
        ],
        "product": "Max_chair",
        "dimention": [
            0.775,
            0.8625,
            0.9625
        ],
        "dimentionText": [
            "31\"",
            "34.5\"",
            "38.5\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Boomerang: Sage",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        -0.15,
                        0.3
                    ]
                },
                "legFinish": {
                    "default": "Nordic",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.25
        ],
        "variant": null,
        "modelLink": "models/Max Chair.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 121,
        "title": "Cokie Dining Chair - Painted",
        "uuid": 121,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.4,
            0
        ],
        "cameraInitPos": [
            -0.57,
            0.45,
            1.59
        ],
        "product": "Cokie_dining_chair_painted",
        "dimention": [
            0.5,
            0.55,
            0.9
        ],
        "dimentionText": [
            "20\"",
            "22\"",
            "36\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "cushionFinish": {
                    "default": "No Cushion",
                    "reapeatFactor": [
                        1.25,
                        1.25
                    ],
                    "offsetFactor": [
                        -0.18,
                        -0.24
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.25
        ],
        "variant": null,
        "modelLink": "models/Cokie Dining Chair - Painted.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 247,
        "title": "Quinn Chair",
        "uuid": 26,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.17,
            0.51,
            1.85
        ],
        "product": "Quinn_chair",
        "dimention": [
            0.725,
            0.825,
            0.862
        ],
        "dimentionText": [
            "29\"",
            "33\"",
            "34.5\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Thatch : Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        -0.15,
                        0.21
                    ]
                },
                "legFinish": {
                    "default": "Nordic",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.25
        ],
        "variant": "Without Nailheads",
        "modelLink": "models/Quinn Chair.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 154,
        "title": "Addy Double Dresser 54",
        "uuid": 154,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.72,
            0.61,
            3.45
        ],
        "product": "Addy_double_dresser_54",
        "dimention": [
            1.35,
            0.475,
            0.9125
        ],
        "dimentionText": [
            "54\"",
            "19\"",
            "36.5\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Addy Double Dresser 54.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 127,
        "title": "Judy Bar Stool - Painted",
        "uuid": 127,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.4,
            0
        ],
        "cameraInitPos": [
            -0.57,
            0.45,
            1.59
        ],
        "product": "Judy_bar_stool_painted",
        "dimention": [
            0.51875,
            0.5,
            1.075
        ],
        "dimentionText": [
            "20.75\"",
            "20\"",
            "43\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluestone",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "cushionFinish": {
                    "default": "No Cushion",
                    "reapeatFactor": [
                        1.25,
                        1.25
                    ],
                    "offsetFactor": [
                        0.13,
                        0.42
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.25
        ],
        "variant": null,
        "modelLink": "models/Judy Bar Stool - Painted.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 228,
        "title": "Charlotte Double Dresser",
        "uuid": 163,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -5,
            1.25,
            10
        ],
        "product": "Charlotte_double_dresser",
        "dimention": [
            1.65,
            0.475,
            0.95
        ],
        "dimentionText": [
            "66\"",
            "19\"",
            "38\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Marine",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "woodTopFinish": {
                    "default": "Painted",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            0,
            5
        ],
        "variant": "Textured Silver",
        "modelLink": "models/Charlotte Double Dresser_silver.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 129,
        "title": "Judy Counter Stool - Painted",
        "uuid": 129,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.6,
            0
        ],
        "cameraInitPos": [
            -0.88,
            0.87,
            2.14
        ],
        "product": "Judy_counter_stool_painted",
        "dimention": [
            0.51875,
            0.5,
            0.925
        ],
        "dimentionText": [
            "20.75\"",
            "20\"",
            "37\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "cushionFinish": {
                    "default": "No Cushion",
                    "reapeatFactor": [
                        1.25,
                        1.25
                    ],
                    "offsetFactor": [
                        0.14,
                        0.38
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.25
        ],
        "variant": null,
        "modelLink": "models/Judy Counter Stool - Painted.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 123,
        "title": "Edna Dining Chair - Painted",
        "uuid": 123,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.4,
            0
        ],
        "cameraInitPos": [
            -0.57,
            0.45,
            1.59
        ],
        "product": "Edna_dining_chair_painted",
        "dimention": [
            0.48125,
            0.5,
            0.925
        ],
        "dimentionText": [
            "19.25\"",
            "20\"",
            "37\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "cushionFinish": {
                    "default": "No Cushion",
                    "reapeatFactor": [
                        1.25,
                        1.25
                    ],
                    "offsetFactor": [
                        0.32,
                        -0.08
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.25
        ],
        "variant": null,
        "modelLink": "models/Edna Dining Chair - Painted.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 226,
        "title": "Lattice Tall Dresser (2-Over-3)",
        "uuid": 226,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -5,
            1.35,
            8.2
        ],
        "product": "Lattice_tall_dresser_2over3",
        "dimention": [
            0.95,
            0.485,
            1.125
        ],
        "dimentionText": [
            "38\"",
            "19\"",
            "45\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Zinnia",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.8
        ],
        "variant": null,
        "modelLink": "models/Lattice Tall Dresser.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 107,
        "title": "Lottie Leaf Console Table",
        "uuid": 107,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.1,
            0
        ],
        "cameraInitPos": [
            -0.68,
            0.62,
            2.05
        ],
        "product": "Lottie_leaf_console_table",
        "dimention": [
            1.5,
            0.425,
            0.75
        ],
        "dimentionText": [
            "60\"",
            "17\"",
            "30\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluestone",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "woodTopFinish": {
                    "default": "Painted",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1.5,
            5
        ],
        "variant": null,
        "modelLink": "models/Lottie Leaf Console Table.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 275,
        "title": "Breakers Dining Table",
        "uuid": 140,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -5.1,
            1.95,
            7.9
        ],
        "product": "Breakers_dining_table",
        "dimention": [
            1,
            2.1,
            0.75
        ],
        "dimentionText": [
            "40\"",
            "84\"",
            "30\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Vast Sky",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "woodTopFinish": {
                    "default": "Painted",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            3.5
        ],
        "variant": "Seats 8",
        "modelLink": "models/Breakers Dining Table_8_Seat.glb",
        "defaultVariant": false,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    },
    {
        "id": 144,
        "title": "Frannie Farmhouse Dining Table",
        "uuid": 144,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -5.1,
            1.95,
            7.9
        ],
        "product": "Frannie_farmhouse_dining_table",
        "dimention": [
            1.8,
            1,
            0.75
        ],
        "dimentionText": [
            "72\"",
            "40\"",
            "30\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Sage",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "woodTopFinish": {
                    "default": "Hand Planed Bourbon Cherry",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            3.5
        ],
        "variant": null,
        "modelLink": "models/Frannie Farmhouse Dining Table.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 177,
        "title": "Frannie Farmhouse Dining Bench",
        "uuid": 177,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -1.13,
            0.5,
            2.27
        ],
        "product": "Frannie_farmhouse_dining_bench",
        "dimention": [
            1.3,
            0.45,
            0.475
        ],
        "dimentionText": [
            "52\"",
            "18\"",
            "19\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "woodTopFinish": {
                    "default": "Painted",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Frannie Farmhouse Dining Bench.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 128,
        "title": "Judy Counter Stool - Natural",
        "uuid": 128,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.6,
            0
        ],
        "cameraInitPos": [
            -0.88,
            0.87,
            2.14
        ],
        "product": "Judy_counter_stool_natural",
        "dimention": [
            0.51875,
            0.5,
            0.925
        ],
        "dimentionText": [
            "20.75\"",
            "20\"",
            "37\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "chairFrameFinish": {
                    "default": "Natural Maple",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "cushionFinish": {
                    "default": "No Cushion",
                    "reapeatFactor": [
                        1.25,
                        1.25
                    ],
                    "offsetFactor": [
                        0.14,
                        0.39
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.25
        ],
        "variant": null,
        "modelLink": "models/Judy Counter Stool - Natural.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 171,
        "title": "Little Cay Desk",
        "uuid": 171,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -2.05,
            1.05,
            3.11
        ],
        "product": "Little_cay_desk",
        "dimention": [
            1.193,
            0.6,
            0.75
        ],
        "dimentionText": [
            "47.75\"",
            "24\"",
            "30\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "woodTopFinish": {
                    "default": "Painted",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            3.5
        ],
        "variant": "Left",
        "modelLink": "models/Little Cay Desk_left.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 195,
        "title": "Nellie 2-Drawer Bedside Table",
        "uuid": 195,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.5,
            0
        ],
        "cameraInitPos": [
            -0.94,
            0.61,
            1.94
        ],
        "product": "Nellie_2drawer_bedside_table",
        "dimention": [
            0.55,
            0.5,
            0.7
        ],
        "dimentionText": [
            "22\"",
            "20\"",
            "28\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "paintColorFinish": {
                    "default": "Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            5
        ],
        "variant": null,
        "modelLink": "models/Nellie 2-Drawer Bedside Table.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 23,
        "title": "Olivia Chair",
        "uuid": 23,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.6,
            0
        ],
        "cameraInitPos": [
            -0.95,
            0.98,
            1.98
        ],
        "product": "Olivia_chair",
        "dimention": [
            0.65,
            0.775,
            1.15
        ],
        "dimentionText": [
            "26\"",
            "31\"",
            "46\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Thatch : Bluebell",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        -0.14,
                        0.2
                    ]
                },
                "legFinish": {
                    "default": "Nordic",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.25
        ],
        "variant": null,
        "modelLink": "models/Olivia Chair.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 5,
        "title": "Barrett Bamboo Chair",
        "uuid": 5,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.37,
            0
        ],
        "cameraInitPos": [
            -1.17,
            0.51,
            1.85
        ],
        "product": "Barrett_bamboo_chair",
        "dimention": [
            0.4625,
            0.525,
            0.9125
        ],
        "dimentionText": [
            "18.5\"",
            "21\"",
            "36.5\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "upholsteryFinish": {
                    "default": "Shore-Bet : Sprout",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        -0.14,
                        0.19
                    ]
                },
                "legPaintColorFinish": {
                    "default": "Nordic",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            1,
            2.25
        ],
        "variant": null,
        "modelLink": "models/Barrett Bamboo Chair.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": true
    },
    {
        "id": 112,
        "title": "Boothbay Dining Chair - Natural",
        "uuid": 112,
        "cameraFOV": 35,
        "cameraTargetPos": [
            0,
            0.3,
            0
        ],
        "cameraInitPos": [
            -5,
            1.25,
            10
        ],
        "product": "Boothbay_dining_chair_natural",
        "dimention": [
            0.475,
            0.5,
            0.85
        ],
        "dimentionText": [
            "19\"",
            "20\"",
            "34\""
        ],
        "cameraNearFarPlane": [
            0.001,
            75
        ],
        "default": {
            "finish": {
                "chairFrameFinish": {
                    "default": "Natural Maple",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                },
                "cushionFinish": {
                    "default": "Oxford Stripe : Greenery",
                    "reapeatFactor": [
                        1,
                        1
                    ],
                    "offsetFactor": [
                        0,
                        0
                    ]
                }
            }
        },
        "repeatFactor": [
            1,
            1
        ],
        "offsetFactor": [
            0,
            0
        ],
        "cameraMinMaxZoomDistance": [
            0,
            5
        ],
        "variant": null,
        "modelLink": "models/Boothbay Dining Chair - Natural.glb",
        "defaultVariant": true,
        "showShadow": true,
        "aoIntensity": 1,
        "homepage": false
    }
]